import {
  Injectable
} from '@angular/core';
import {
  Router
} from '@angular/router';
import {
  BehaviorSubject,
  Observable
} from 'rxjs';
import {
  map
} from 'rxjs/operators';
import {
  HttpClient,
  HttpHeaders
} from '@angular/common/http';
import {
  environment
} from '../../environments/environment';
import {
  User,
  WebAccessUser,
  SysUser
} from '../_models';
import {
  DialogBox,
  WebServiceParam,
  MauiWebServiceParam,
  WebServiceRequestParam,
  MauiWebServiceDatasheetParam
} from '../_models';
import {
  Subject
} from 'rxjs';
import {
  parse
} from 'fast-xml-parser';
@Injectable({
  providedIn: 'root'
})
export class AccountService {
  webServiceRequestParam: WebServiceRequestParam[] = [];
  private webServiceParam: WebServiceParam[] = [];
  private mauiWebServiceParam: MauiWebServiceParam[] = [];
  public webAccessUser:  WebAccessUser[]  =[];
  private mauiWebServiceDatasheetParam: MauiWebServiceDatasheetParam[] = [];
  public sysUser: SysUser[] = [];
public newSysUser: Observable < SysUser[] > ;
  private mauiWebServiceParamUpdated = new Subject < {
    mauiWebServiceParam: MauiWebServiceParam[]
  } > ();
  private webServiceParamUpdated = new Subject < {
    webServiceParam: WebServiceParam[]
  } > ();
  private mauiWebServiceDatasheetParamUpdated = new Subject < {
    mauiWebServiceDatasheetParam: MauiWebServiceDatasheetParam[]
  } > ();
  private webAccessUserParamUpdated = new Subject < {
    webAccessUser: WebAccessUser[]
  } > ();
  public dialogBox: DialogBox[] = [];
  private userSubject: BehaviorSubject < User > ;
  public user: Observable < User > ;
//  public webAccessUser: Observable < WebAccessUser[] > ;
  public newWebAccessUser: Observable < WebAccessUser[] > ;
 // public webAccessUser: WebAccessUser[]=[];
  public username: any;
  public password: any;
  userID: string;
  webAccessPassword: string;
  isLoggedIn: boolean = true;
  xmlRequest: any;
  redirectUrl: any;
  serviceRequestXmlContent: any;
  serviceResponseXmlContent: any;
  serviceTitleXmlContent: string;
  serviceXmlValidateRequest: any;
  serviceXmlValidateResponse: any;
  date: Date = new Date();
  trnuid: any;
  constructor(
    private router: Router,
    private http: HttpClient
  ) {
    this.userSubject = new BehaviorSubject < User > (JSON.parse(localStorage.getItem('user')));
    this.user = this.userSubject.asObservable();
  }
  httpOptions: Object = {
    headers: new HttpHeaders({
      'Content-Type': 'application/xml',
    }),
    observe: 'response' as 'body',
    responseType: 'text'
  };
  tokengeneration(username, password) {
    let bodyContent = ` <?xml version='1.0' encoding='UTF-8' ?>
     <DGX><SIGNONMSGSRQV1><SONRQ><USERID>` + username + `</USERID><USERPASS>` + password + `</USERPASS></SONRQ></SIGNONMSGSRQV1></DGX>`;
    this.xmlRequest = 'Request=' + escape(bodyContent);
  //  return this.http.post('https://toolkit-wsdl-stg.dnb.com/rest/Toolkit/Authentication', this.xmlRequest, this.httpOptions);
  return this.http.post(`${environment.sessionUrl}`, this.xmlRequest, this.httpOptions);
  }   
  public get userValue(): User {
    return this.userSubject.value;
  }
  login(token) {
    return this.http.post < User > (`${environment.apiUrl}/users/authenticate`, {
        token
      })
      .pipe(map(user => {
        // store user details and jwt token in local storage to keep user logged in between page refreshes
        var now = new Date().getTime();
        localStorage.setItem('token', token);
        localStorage.setItem('saved', now.toString());
        this.userSubject.next(user);
        return user;
      }));
  }
  logout() {
    // remove user from local storage and set current user to null
    localStorage.removeItem('user');
    this.userSubject.next(null);
    this.isLoggedIn = false;
    this.router.navigate(['/account/login']);
    return;
  }
  webAccessSignup(webAccessUser: WebAccessUser) {
  //  return this.http.post(`${environment.apiUrl}/users/register`, webAccessUser);
 

   this.newWebAccessUser= new Observable(observer => {
   // observer.next(1);
    this.webAccessUser['username'] = webAccessUser.username;
    this.webAccessUser['password'] = webAccessUser.password;
    /*this.webAccessUserParamUpdated.next({
      webAccessUser: this.webAccessUser
    });*/
    observer.next(this.webAccessUser);
//    observer.complete();
  });

  return  this.newWebAccessUser;
  
 /* this.webAccessUser['username'] = 
  this.webAccessUser['password'] = 
  this.webAccessUserParamUpdated.next({
    webAccessUser: this.webAccessUser
  });*/


  }

  
  getProvince(shortValue) {
    let provinceName = '';
    this.province.map(function (value) {
      if (value.short == shortValue) {
        provinceName = value.name;
      }
    });
    return provinceName;
  }
  dunsNoFormat(dunsNo) {
    var num = new Number(dunsNo);
    var formattedDunsNo = num.toString();
    if (formattedDunsNo.length == 8) {
      formattedDunsNo = '0' + formattedDunsNo;
    } else if (formattedDunsNo.length == 7) {
      formattedDunsNo = '00' + formattedDunsNo;
    } else if (formattedDunsNo.length == 6) {
      formattedDunsNo = '000' + formattedDunsNo;
    } else if (formattedDunsNo.length == 5) {
      formattedDunsNo = '0000' + formattedDunsNo;
    }
    if (formattedDunsNo.length == 9) {
      var i;
      var dunsNoFormat = '';
      for (i = 0; i < 9; i++) {
        if (i == 1 || i == 4) {
          dunsNoFormat = dunsNoFormat + formattedDunsNo[i] + "-";
        } else {
          dunsNoFormat = dunsNoFormat + formattedDunsNo[i];
        }
      }
    }
    return dunsNoFormat;
  }
  getState(shortValue) {
    var stateName = '';
    this.state.map(function (value) {
      if (value.short == shortValue) {
        stateName = value.name;
      }
    });
    if (stateName == "") {
      this.province.map(function (value) {
        if (value.short == shortValue) {
          stateName = value.name
        }
      });
    }
    return stateName;
  }
  titleCaseWord(word: string) {
    if (!word) return word;
    return word[0].toUpperCase() + word.substr(1).toLowerCase();
  }
  onlyUnique(value, index, self) {
    return self.indexOf(value) === index;
  }
  getCountryName(countryCode) {
    let Country = "";
    this.country.map(function (value) {
      var short = value.short.split('-');
      if (short[0] == countryCode) {
        Country = value.name;
      }
    });
    return Country;
  }
  getCountry(shortValue) {
    var countryId;
    this.country.map(function (value) {
      var short = value.short.split('-');
      if (short[0] == shortValue) {
        countryId = short[1];
      }
    });
    return countryId;
  }
  getCountryCode(shortValue) {
    var countryCode;
    this.country.map(function (value) {
      var short = value.short.split('-');
      if (short[1] == shortValue) {
        countryCode = short[0];
      }
    });
    return countryCode;
  }
  getCountryTrade(countryCode) {
    var countryTrade = '';
    this.country.map(function (value) {
      var short = value.short.split('-');
      if (short[0] == countryCode) {
        countryTrade = value.trade;
      }
    });
    return countryTrade;
  }
  register(user: User) {
    return this.http.post(`${environment.apiUrl}/users/register`, user);
  }

  getWebAccessUserParamUpdateListener() {
    return this.webAccessUserParamUpdated.asObservable();
  }

  getMauiWebServiceParamUpdateListener() {
    return this.mauiWebServiceParamUpdated.asObservable();
  }
  getMauiWebServiceDatasheetParamUpdateListener() {
    return this.mauiWebServiceDatasheetParamUpdated.asObservable();
  }
  getAll() {
    return this.http.get < User[] > (`${environment.apiUrl}/users`);
  }
  getById(id: string) {
    return this.http.get < User > (`${environment.apiUrl}/users/${id}`);
  }
  update(id, params) {
    return this.http.put(`${environment.apiUrl}/users/${id}`, params)
      .pipe(map(x => {
        // update stored user if the logged in user updated their own record
        if (id == this.userValue.id) {
          // update local storage
          const user = {
            ...this.userValue,
            ...params
          };
          localStorage.setItem('user', JSON.stringify(user));
          // publish updated user to subscribers
          this.userSubject.next(user);
        }
        return x;
      }));
  }
  delete(id: string) {
    return this.http.delete(`${environment.apiUrl}/users/${id}`)
      .pipe(map(x => {
        // auto logout if the logged in user deleted their own record
        if (id == this.userValue.id) {
          this.logout();
        }
        return x;
      }));
  }
  //https://toolkit-wsdl.dnb.com/services/ToolkitXMLGateway
  escapeText(text) {
    var map = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      //  '"': '&quot;',
      "'": '&quot;'
    };
    return text.replace(/[&<>"']/g, function (m) {
      return map[m];
    });
  }
  sysUserDetail(sysUserDetail){
       this.newSysUser = new Observable(sysObserver => {
      this.sysUser['u'] = sysUserDetail.u;
      this.sysUser['p'] = sysUserDetail.p;
      sysObserver.next(this.sysUser);
    
    });

    return this.newSysUser;
     
  }
  getWebServiceParamUpdateListener() {
    return this.webServiceParamUpdated.asObservable();
  }
  getUserId(){
    return this.userID;
  }
  setUserId(id: string): void{
    this.userID = id;
  }
  getPassword(){
    return this.webAccessPassword;
  }
  setPassword(password: string):void{
    this.webAccessPassword = password;
  }
  mauiAnotherPostXml(bodyContent, link, validateResponse) {
    let token = localStorage.getItem('token');
    let httpOptions: object = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        'Authorization': (token != null ? token : '')
      //  'Access-Control-Allow-Headers': 'Content-Type,Authorization'
      }),
      'responseType': 'text'
    };
    this.xmlRequest = 'Request=' + escape(bodyContent);
    return this.http.post(`${environment.apiUrl}`, this.xmlRequest, httpOptions)
      .subscribe((result) => {
          this.webServiceParam['serviceResponseXmlContent'] = result.toString().replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace("&quot;", "'");
          this.webServiceParam['serviceTitleXmlContent'] = link;
          this.webServiceParam['serviceXmlValidateResponse'] = validateResponse;
          this.webServiceParamUpdated.next({
            webServiceParam: this.webServiceParam
          });
        },
        error => {
          console.log('Error');
          console.log(error.error.text);
        });
  }
  postXml(bodyContent, link, validateResponse) {
    this.xmlRequest = 'Request=' + escape(bodyContent);
    return this.http.post(`${environment.apiUrl}`, this.xmlRequest, {
        responseType: 'text'
      })
      .subscribe((result) => {
          this.webServiceParam['serviceResponseXmlContent'] = result.replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace("&quot;", "'");
          this.webServiceParam['serviceTitleXmlContent'] = link;
          this.webServiceParam['serviceXmlValidateResponse'] = validateResponse;
          this.webServiceParamUpdated.next({
            webServiceParam: this.webServiceParam
          });
        },
        error => {
          console.log('Error');
          console.log(error.error.text);
        });
  }
  mauiPostXml(bodyContent, link, validateResponse) {
    let token = localStorage.getItem('token');
    let httpOptions: object = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        'Authorization': (token != null ? token : '')
      //  'Access-Control-Allow-Headers': 'Content-Type,Authorization'
      }),
      'responseType': 'text'
    };
    this.xmlRequest = 'Request=' + escape(bodyContent);
    return this.http.post(`${environment.apiUrl}`, this.xmlRequest, httpOptions)
      //return this.http.post(`${environment.apiUrl}`,  this.xmlRequest,{responseType:  'text'} )
      .subscribe((result) => {
          this.mauiWebServiceParam['serviceResponseXmlContent'] = result.toString().replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace("&quot;", "'");
          this.mauiWebServiceParam['serviceTitleXmlContent'] = link;
          this.mauiWebServiceParam['serviceXmlValidateResponse'] = validateResponse;
          this.mauiWebServiceParamUpdated.next({
            mauiWebServiceParam: this.mauiWebServiceParam
          });
        },
        error => {
          console.log('Error');
          console.log(error.error.text);
        });
  }
  mauiDatasheetPostXml(bodyContent, link, validateResponse) {
    let token = localStorage.getItem('token');
    let httpOptions: object = {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
        'Authorization': (token != null ? token : '')
       // 'Access-Control-Allow-Headers': 'Content-Type,Authorization'
      }),
      'responseType': 'text'
    };
    this.xmlRequest = 'Request=' + escape(bodyContent);
    return this.http.post(`${environment.apiUrl}`, this.xmlRequest, httpOptions)
      .subscribe((result) => {
          this.mauiWebServiceDatasheetParam['serviceResponseXmlContent'] = result.toString().replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace("&quot;", "'");
          this.mauiWebServiceDatasheetParam['serviceTitleXmlContent'] = link;
          this.mauiWebServiceDatasheetParam['serviceXmlValidateResponse'] = validateResponse;
          this.mauiWebServiceDatasheetParamUpdated.next({
            mauiWebServiceDatasheetParam: this.mauiWebServiceDatasheetParam
          });
        },
        error => {
          console.log('Error');
          console.log(error.error.text);
        });
  }
  state = [{
      id: 1,
      short: "AL",
      name: "Alabama",
    },
    {
      id: 2,
      short: "AR",
      name: "Arkansas",
    },
    {
      id: 3,
      short: "AZ",
      name: "Arizona",
    },
    {
      id: 4,
      short: "AK",
      name: "Alaska",
    },
    {
      id: 5,
      short: "CA",
      name: "California",
    },
    {
      id: 6,
      short: "CO",
      name: "Colorado",
    },
    {
      id: 7,
      short: "CT",
      name: "Connecticut",
    },
    {
      id: 8,
      short: "DT",
      name: "Delaware",
    },
    {
      id: 9,
      short: "FL",
      name: "Florida",
    },
    {
      id: 10,
      short: "GA",
      name: "Georgia",
    },
    {
      id: 11,
      short: "HI",
      name: "Hawaii",
    },
    {
      id: 12,
      short: "ID",
      name: "Idaho",
    },
    {
      id: 13,
      short: "IL",
      name: "Illinois",
    },
    {
      id: 14,
      short: "IN",
      name: "Indiana",
    },
    {
      id: 15,
      short: "IA",
      name: "Iowa",
    },
    {
      id: 16,
      short: "KS",
      name: "Kansas",
    },
    {
      id: 17,
      short: "KY",
      name: "Kentucky",
    },
    {
      id: 18,
      short: "LA",
      name: "Louisiana",
    },
    {
      id: 19,
      short: "ME",
      name: "Maine",
    },
    {
      id: 20,
      short: "MD",
      name: "Maryland",
    },
    {
      id: 21,
      short: "MA",
      name: "Massachusetts",
    },
    {
      id: 22,
      short: "MI",
      name: "Michigan",
    },
    {
      id: 23,
      short: "MN",
      name: "Minnesota",
    },
    {
      id: 24,
      short: "MS",
      name: "Mississippi",
    },
    {
      id: 25,
      short: "MO",
      name: "Missouri",
    },
    {
      id: 26,
      short: "MT",
      name: "Montana",
    },
    {
      id: 27,
      short: "NE",
      name: "Nebraska",
    },
    {
      id: 28,
      short: "NV",
      name: "Nevada",
    },
    {
      id: 29,
      short: "NH",
      name: "New Hampshire",
    },
    {
      id: 30,
      short: "NJ",
      name: "New Jersey",
    },
    {
      id: 31,
      short: "NM",
      name: "New Mexico",
    },
    {
      id: 32,
      short: "NY",
      name: "New York",
    },
    {
      id: 33,
      short: "NC",
      name: "North Carolina",
    },
    {
      id: 34,
      short: "ND",
      name: "North Dakota",
    },
    {
      id: 35,
      short: "OH",
      name: "Ohio",
    },
    {
      id: 36,
      short: "OK",
      name: "Oklahoma",
    },
    {
      id: 37,
      short: "OR",
      name: "Oregon",
    },

    {
      id: 38,
      short: "PA",
      name: "Pennsylvania",
    },

    {
      id: 39,
      short: "RI",
      name: "Rhode Island",
    },

    {
      id: 40,
      short: "SC",
      name: "South Carolina",
    },

    {
      id: 41,
      short: "SD",
      name: "South Dakota",
    },

    {
      id: 42,
      short: "TN",
      name: "Tennessee",
    },
    {
      id: 43,
      short: "TX",
      name: "Texas",
    },
    {
      id: 44,
      short: "UT",
      name: "Utah",
    },
    {
      id: 45,
      short: "VT",
      name: "Vermont",
    },
    {
      id: 46,
      short: "VA",
      name: "Virginia",
    },
    {
      id: 47,
      short: "VI",
      name: "Virgin Islands",
    },
    {
      id: 48,
      short: "WA",
      name: "Washington",
    },
    {
      id: 49,
      short: "WV",
      name: "West Virginia",
    },
    {
      id: 50,
      short: "WI",
      name: "Wisconsin",
    },
    {
      id: 51,
      short: "WY",
      name: "Wyoming",
    },
    {
      id: 52,
      short: "DC",
      name: "District of Columbia",
    },
    {
      id: 53,
      short: "PR",
      name: "Puerto Rico",
    }
  ];

  country = [{
      id: 1,
      short: "XB-913",
      name: "ABU DHABI",
      trade: "N"
    },
    {
      id: 2,
      short: "AY-935",
      name: "ADMIRALTY ISLANDS",
      trade: "N"
    },


    {
      id: 3,
      short: "AF-4",
      name: "AFGHANISTAN",
      trade: "N"
    },

    {
      id: 4,
      short: "XA-915",
      name: "AJMAN",
      trade: "N"
    },
    {
      id: 5,
      short: "XL-981",
      name: "AL AIN",
      trade: "N"
    },
    {
      id: 6,
      short: "AL-8",
      name: "ALBANIA",
      trade: "R"
    },
    {
      id: 7,
      short: "DZ-12",
      name: "ALGERIA",
      trade: "N"
    },
    {
      id: 8,
      short: "AS-16",
      name: "AMERICAN SAMOA",
      trade: "A"
    },
    {
      id: 9,
      short: "AD-20",
      name: "ANDORRA",
      trade: "A"
    },
    {
      id: 10,
      short: "AO-24",
      name: "ANGOLA",
      trade: "N"
    },
    {
      id: 11,
      short: "AI-660",
      name: "ANGUILLA",
      trade: "N"
    },
    {
      id: 12,
      short: "AG-28",
      name: "ANTIGUA AND BARBUDA",
      trade: "N"
    },
    {
      id: 13,
      short: "AR-32",
      name: "ARGENTINA",
      trade: "N"
    },
    {
      id: 14,
      short: "AM-51",
      name: "ARMENIA",
      trade: "R"
    },
    {
      id: 15,
      short: "AW-533",
      name: "ARUBA",
      trade: "N"
    },
    {
      id: 16,
      short: "AC-983",
      name: "ASCENSION ISLAND",
      trade: "N"
    },
    {
      id: 17,
      short: "AU-36",
      name: "AUSTRALIA",
      trade: "A"
    },
    {
      id: 18,
      short: "AT-40",
      name: "AUSTRIA",
      trade: "A"
    },
    {
      id: 19,
      short: "AZ-31",
      name: "AZERBAIJAN",
      trade: "R"
    },
    {
      id: 20,
      short: "BS-44",
      name: "BAHAMAS",
      trade: "N"
    },
    {
      id: 21,
      short: "BH-48",
      name: "BAHRAIN",
      trade: "N"
    },
    {
      id: 22,
      short: "BD-50",
      name: "BANGLADESH",
      trade: "N"
    },
    {
      id: 23,
      short: "BB-52",
      name: "BARBADOS",
      trade: "N"
    },
    {
      id: 24,
      short: "BE-56",
      name: "BELGIUM",
      trade: "A"
    },
    {
      id: 25,
      short: "BZ-84",
      name: "BELIZE",
      trade: "N"
    },
    {
      id: 26,
      short: "BJ-204",
      name: "BENIN, PEOPLES REPUBLIC OF",
      trade: "N"
    },
    {
      id: 27,
      short: "BM-60",
      name: "BERMUDA",
      trade: "N"
    },
    {
      id: 28,
      short: "BT-64",
      name: "BHUTAN",
      trade: "N"
    },
    {
      id: 29,
      short: "BO-68",
      name: "BOLIVIA",
      trade: "N"
    },
    {
      id: 30,
      short: "BQ-535",
      name: "BONAIRE, ST EUSTATIUS AND SABA",
      trade: "N"
    },
    {
      id: 31,
      short: "BA-70",
      name: "BOSNIA AND HERZEGOVINA",
      trade: "R"
    },
    {
      id: 32,
      short: "BW-72",
      name: "BOTSWANA",
      trade: "A"
    },
    {
      id: 33,
      short: "BV-74",
      name: "BOUVET ISLAND",
      trade: "N"
    },
    {
      id: 34,
      short: "BR-76",
      name: "BRAZIL",
      trade: "N"
    },
    {
      id: 35,
      short: "VG-92",
      name: "BRITISH VIRGIN ISLANDS",
      trade: "N"
    },
    {
      id: 36,
      short: "BN-96",
      name: "BRUNEI",
      trade: "N"
    },
    {
      id: 37,
      short: "BG-100",
      name: "BULGARIA",
      trade: "R"
    },
    {
      id: 38,
      short: "BF-854",
      name: "BURKINA FASO",
      trade: "N"
    },
    {
      id: 39,
      short: "MM-104",
      name: "BURMA (MYANMAR)",
      trade: "N"
    },
    {
      id: 40,
      short: "BI-108",
      name: "BURUNDI",
      trade: "N"
    },
    {
      id: 41,
      short: "BY-112",
      name: "BYELORUSSIA",
      trade: "N"
    },
    {
      id: 42,
      short: "CM-120",
      name: "CAMEROON",
      trade: "N"
    },
    {
      id: 43,
      short: "CA-124",
      name: "CANADA",
      trade: "R"
    },
    {
      id: 44,
      short: "CV-132",
      name: "CAPE VERDE, REPUBLIC OF",
      trade: "N"
    },
    {
      id: 45,
      short: "CB-943",
      name: "CAROLINE ISLANDS",
      trade: "N"
    },
    {
      id: 46,
      short: "KY-136",
      name: "CAYMAN ISLANDS",
      trade: "N"
    },
    {
      id: 47,
      short: "CF-140",
      name: "CENTRAL AFRICA REPUBLIC",
      trade: "N"
    },
    {
      id: 48,
      short: "TD-148",
      name: "CHAD",
      trade: "N"
    },
    {
      id: 49,
      short: "CL-152",
      name: "CHILE",
      trade: "N"
    },
    {
      id: 50,
      short: "CN-156",
      name: "CHINA",
      trade: "N"
    },
    {
      id: 51,
      short: "CX-162",
      name: "CHRISTMAS ISLAND",
      trade: "A"
    },
    {
      id: 52,
      short: "CO-170",
      name: "COLOMBIA",
      trade: "N"
    },
    {
      id: 53,
      short: "KM-174",
      name: "COMOROS",
      trade: "N"
    },
    {
      id: 54,
      short: "CG-178",
      name: "CONGO",
      trade: "N"
    },
    {
      id: 55,
      short: "CD-180",
      name: "CONGO DEMOCRATIC REPUBLIC",
      trade: "N"
    },
    {
      id: 56,
      short: "CK-184",
      name: "COOK ISLANDS",
      trade: "A"
    },
    {
      id: 57,
      short: "CR-188",
      name: "COSTA RICA",
      trade: "N"
    },
    {
      id: 58,
      short: "HR-191",
      name: "CROATIA",
      trade: "R"
    },
    {
      id: 59,
      short: "CU-192",
      name: "CUBA",
      trade: "N"
    },
    {
      id: 60,
      short: "CW-531",
      name: "CURACAO",
      trade: "N"
    },
    {
      id: 61,
      short: "CY-196",
      name: "CYPRUS",
      trade: "N"
    },
    {
      id: 62,
      short: "CZ-203",
      name: "CZECH REPUBLIC",
      trade: "A"
    },
    {
      id: 63,
      short: "DK-208",
      name: "DENMARK",
      trade: "N"
    },
    {
      id: 64,
      short: "DJ-262",
      name: "DJIBOUTI",
      trade: "N"
    },
    {
      id: 65,
      short: "DM-212",
      name: "DOMINICA",
      trade: "N"
    },
    {
      id: 66,
      short: "DO-214",
      name: "DOMINICAN REPUBLIC",
      trade: "N"
    },
    {
      id: 68,
      short: "XD-923",
      name: "DUBAI",
      trade: "N"
    },
    {
      id: 69,
      short: "TP-626",
      name: "EAST TIMOR",
      trade: "N"
    },
    {
      id: 70,
      short: "EC-218",
      name: "ECUADOR",
      trade: "N"
    },
    {
      id: 71,
      short: "EG-818",
      name: "EGYPT",
      trade: "N"
    },
    {
      id: 72,
      short: "SV-222",
      name: "EL SALVADOR",
      trade: "N"
    },
    {
      id: 73,
      short: "GQ-226",
      name: "EQUATORIAL GUINEA",
      trade: "N"
    },
    {
      id: 74,
      short: "ER-232",
      name: "ERITREA",
      trade: "N"
    },
    {
      id: 75,
      short: "EE-233",
      name: "ESTONIA",
      trade: "R"
    },
    {
      id: 76,
      short: "ET-231",
      name: "ETHIOPIA",
      trade: "N"
    },
    {
      id: 77,
      short: "FK-238",
      name: "FALKLAND ISLANDS",
      trade: "N"
    },
    {
      id: 78,
      short: "FO-234",
      name: "FAROE ISLANDS",
      trade: "N"
    },
    {
      id: 79,
      short: "FJ-242",
      name: "FIJI",
      trade: "A"
    },
    {
      id: 80,
      short: "FI-246",
      name: "FINLAND",
      trade: "N"
    },
    {
      id: 81,
      short: "FR-250",
      name: "FRANCE",
      trade: "A"
    },
    {
      id: 82,
      short: "GF-254",
      name: "FRENCH GUIANA",
      trade: "A"
    },
    {
      id: 83,
      short: "PF-258",
      name: "FRENCH POLYNESIA/TAHITI",
      trade: "A"
    },
    {
      id: 84,
      short: "XF-925",
      name: "FUJAIRAH",
      trade: "N"
    },
    {
      id: 85,
      short: "GA-266",
      name: "GABON",
      trade: "N"
    },
    {
      id: 86,
      short: "GM-270",
      name: "GAMBIA",
      trade: "N"
    },
    {
      id: 87,
      short: "GE-268",
      name: "GEORGIA",
      trade: "R"
    },
    {
      id: 88,
      short: "DE-276",
      name: "GERMANY",
      trade: "A"
    },
    {
      id: 89,
      short: "GH-288",
      name: "GHANA",
      trade: "N"
    },
    {
      id: 90,
      short: "GI-292",
      name: "GIBRALTAR",
      trade: "R"
    },
    {
      id: 91,
      short: "GR-300",
      name: "GREECE",
      trade: "R"
    },
    {
      id: 92,
      short: "GL-304",
      name: "GREENLAND",
      trade: "N"
    },
    {
      id: 93,
      short: "GD-308",
      name: "GRENADA",
      trade: "N"
    },
    {
      id: 94,
      short: "GP-312",
      name: "GUADELOUPE",
      trade: "A"
    },
    {
      id: 95,
      short: "GU-316",
      name: "GUAM",
      trade: "A"
    },
    {
      id: 96,
      short: "GT-320",
      name: "GUATEMALA",
      trade: "N"
    },
    {
      id: 97,
      short: "GN-324",
      name: "GUINEA",
      trade: "N"
    },
    {
      id: 98,
      short: "GW-624",
      name: "GUINEA BISSAU",
      trade: "N"
    },
    {
      id: 99,
      short: "GY-328",
      name: "GUYANA",
      trade: "N"
    },
    {
      id: 100,
      short: "HT-332",
      name: "HAITI",
      trade: "N"
    },
    {
      id: 101,
      short: "VA-336",
      name: "HOLY SEE (VATICAN CITY STATE)",
      trade: "N"
    },
    {
      id: 102,
      short: "HN-340",
      name: "HONDURAS",
      trade: "N"
    },
    {
      id: 103,
      short: "HK-344",
      name: "HONG KONG S.A.R.",
      trade: "N"
    },
    {
      id: 104,
      short: "HU-348",
      name: "HUNGARY",
      trade: "A"
    },
    {
      id: 105,
      short: "IS-352",
      name: "ICELAND",
      trade: "R"
    },
    {
      id: 106,
      short: "IN-356",
      name: "INDIA",
      trade: "N"
    },
    {
      id: 107,
      short: "ID-360",
      name: "INDONESIA",
      trade: "N"
    },
    {
      id: 108,
      short: "IR-364",
      name: "IRAN",
      trade: "N"
    },
    {
      id: 109,
      short: "IQ-368",
      name: "IRAQ",
      trade: "N"
    },
    {
      id: 110,
      short: "IE-372",
      name: "IRELAND",
      trade: "N"
    },
    {
      id: 111,
      short: "IL-376",
      name: "ISRAEL",
      trade: "N"
    },
    {
      id: 112,
      short: "IT-380",
      name: "ITALY",
      trade: "A"
    },
    {
      id: 113,
      short: "CI-384",
      name: "IVORY COAST/COTE D IVOIRE",
      trade: "N"
    },
    {
      id: 114,
      short: "JM-388",
      name: "JAMAICA",
      trade: "N"
    },
    {
      id: 115,
      short: "JP-392",
      name: "JAPAN",
      trade: "N"
    },
    {
      id: 116,
      short: "JO-400",
      name: "JORDAN",
      trade: "N"
    },
    {
      id: 117,
      short: "KH-116",
      name: "KAMPUCHEA",
      trade: "N"
    },
    {
      id: 118,
      short: "KZ-398",
      name: "KAZAKHSTAN",
      trade: "R"
    },
    {
      id: 119,
      short: "KE-404",
      name: "KENYA",
      trade: "N"
    },
    {
      id: 120,
      short: "KI-296",
      name: "KIRIBATI",
      trade: "A"
    },
    {
      id: 121,
      short: "KP-408",
      name: "KOREA, NORTH",
      trade: "N"
    },
    {
      id: 122,
      short: "KR-410",
      name: "KOREA, REPUBLIC OF",
      trade: "N"
    },
    {
      id: 123,
      short: "XK-926",
      name: "KOSOVO",
      trade: "N"
    },
    {
      id: 124,
      short: "KW-414",
      name: "KUWAIT",
      trade: "N"
    },
    {
      id: 125,
      short: "KG-417",
      name: "KYRGYZSTAN",
      trade: "R"
    },
    {
      id: 126,
      short: "LA-418",
      name: "LAOS",
      trade: "N"
    },
    {
      id: 127,
      short: "LV-428",
      name: "LATVIA",
      trade: "R"
    },
    {
      id: 128,
      short: "LB-422",
      name: "LEBANON",
      trade: "N"
    },
    {
      id: 129,
      short: "LS-426",
      name: "LESOTHO",
      trade: "A"
    },
    {
      id: 130,
      short: "LR-430",
      name: "LIBERIA",
      trade: "N"
    },
    {
      id: 131,
      short: "LY-434",
      name: "LIBYA",
      trade: "N"
    },
    {
      id: 132,
      short: "LI-438",
      name: "LIECHTENSTEIN",
      trade: "A"
    },
    {
      id: 133,
      short: "LT-440",
      name: "LITHUANIA",
      trade: "R"
    },
    {
      id: 134,
      short: "LU-442",
      name: "LUXEMBOURG",
      trade: "A"
    },
    {
      id: 135,
      short: "MO-446",
      name: "MACAO S.A.R.",
      trade: "N"
    },
    {
      id: 136,
      short: "MK-937",
      name: "MACEDONIA",
      trade: "R"
    },
    {
      id: 137,
      short: "MG-450",
      name: "MADAGASGAR",
      trade: "N"
    },
    {
      id: 138,
      short: "MW-454",
      name: "MALAWI",
      trade: "N"
    },
    {
      id: 139,
      short: "MY-458",
      name: "MALAYSIA",
      trade: "N"
    },
    {
      id: 140,
      short: "MV-462",
      name: "MALDIVES",
      trade: "N"
    },
    {
      id: 141,
      short: "ML-466",
      name: "MALI",
      trade: "N"
    },
    {
      id: 142,
      short: "MT-470",
      name: "MALTA",
      trade: "R"
    },
    {
      id: 143,
      short: "MH-584",
      name: "MARSHALL ISLANDS",
      trade: "A"
    },
    {
      id: 144,
      short: "MQ-474",
      name: "MARTINIQUE",
      trade: "A"
    },
    {
      id: 145,
      short: "MR-478",
      name: "MAURITANIA",
      trade: "N"
    },
    {
      id: 146,
      short: "MU-480",
      name: "MAURITIUS",
      trade: "N"
    },
    {
      id: 147,
      short: "YT-175",
      name: "MAYOTTE",
      trade: "N"
    },
    {
      id: 148,
      short: "MX-484",
      name: "MEXICO",
      trade: "N"
    },
    {
      id: 149,
      short: "IM-933",
      name: "MIDWAY ISLAND",
      trade: "N"
    },
    {
      id: 150,
      short: "MD-498",
      name: "MOLDOVA",
      trade: "R"
    },
    {
      id: 151,
      short: "MC-492",
      name: "MONACO",
      trade: "A"
    },
    {
      id: 152,
      short: "MN-496",
      name: "MONGOLIA",
      trade: "N"
    },
    {
      id: 153,
      short: "ME-499",
      name: "MONTENEGRO",
      trade: "R"
    },
    {
      id: 154,
      short: "MS-500",
      name: "MONTSERRAT",
      trade: "N"
    },
    {
      id: 155,
      short: "MA-504",
      name: "MOROCCO",
      trade: "N"
    },
    {
      id: 156,
      short: "MZ-508",
      name: "MOZAMBIQUE",
      trade: "N"
    },
    {
      id: 157,
      short: "FM-583",
      name: "Micronesia, Federated States of",
      trade: "A"
    },
    {
      id: 158,
      short: "NA-516",
      name: "NAMIBIA",
      trade: "A"
    },
    {
      id: 159,
      short: "NR-520",
      name: "NAURU",
      trade: "A"
    },
    {
      id: 160,
      short: "NP-524",
      name: "NEPAL",
      trade: "N"
    },
    {
      id: 161,
      short: "NL-528",
      name: "NETHERLANDS",
      trade: "A"
    },
    {
      id: 162,
      short: "NC-540",
      name: "NEW CALEDONIA",
      trade: "N"
    },
    {
      id: 163,
      short: "NZ-554",
      name: "NEW ZEALAND",
      trade: "A"
    },
    {
      id: 164,
      short: "NI-558",
      name: "NICARAGUA",
      trade: "N"
    },
    {
      id: 165,
      short: "NE-562",
      name: "NIGER",
      trade: "N"
    },
    {
      id: 166,
      short: "NG-566",
      name: "NIGERIA",
      trade: "N"
    },
    {
      id: 167,
      short: "NU-570",
      name: "NIUE",
      trade: "N"
    },
    {
      id: 168,
      short: "NF-574",
      name: "NORFOLK ISLAND",
      trade: "A"
    },
    {
      id: 169,
      short: "MP-580",
      name: "NORTHERN MARIANA ISLANDS",
      trade: "N"
    },
    {
      id: 170,
      short: "NO-578",
      name: "NORWAY",
      trade: "N"
    },
    {
      id: 171,
      short: "OM-512",
      name: "OMAN",
      trade: "N"
    },
    {
      id: 172,
      short: "PK-586",
      name: "PAKISTAN",
      trade: "N"
    },
    {
      id: 173,
      short: "PW-585",
      name: "PALAU",
      trade: "N"
    },
    {
      id: 175,
      short: "PS-275",
      name: "PALESTINE, STATE OF",
      trade: "N"
    },
    {
      id: 176,
      short: "PA-591",
      name: "PANAMA",
      trade: "N"
    },
    {
      id: 177,
      short: "PG-598",
      name: "PAPUA NEW GUINEA",
      trade: "A"
    },
    {
      id: 178,
      short: "PY-600",
      name: "PARAGUAY",
      trade: "N"
    },
    {
      id: 179,
      short: "PE-604",
      name: "PERU",
      trade: "N"
    },
    {
      id: 180,
      short: "PH-608",
      name: "PHILIPPINES",
      trade: "N"
    },
    {
      id: 181,
      short: "PL-616",
      name: "POLAND",
      trade: "A"
    },
    {
      id: 182,
      short: "PT-620",
      name: "PORTUGAL",
      trade: "A"
    },
    {
      id: 183,
      short: "PR-630",
      name: "Puerto Rico",
      trade: "R"
    },
    {
      id: 184,
      short: "QA-634",
      name: "QATAR",
      trade: "N"
    },
    {
      id: 185,
      short: "XR-917",
      name: "RAS AL KHAIMAH",
      trade: "N"
    },
    {
      id: 186,
      short: "RE-638",
      name: "REUNION",
      trade: "A"
    },
    {
      id: 187,
      short: "RO-642",
      name: "ROMANIA",
      trade: "R"
    },
    {
      id: 188,
      short: "RU-643",
      name: "RUSSIA",
      trade: "R"
    },
    {
      id: 189,
      short: "RW-646",
      name: "RWANDA",
      trade: "N"
    },
    {
      id: 190,
      short: "SH-654",
      name: "SAINT HELENA",
      trade: "N"
    },
    {
      id: 191,
      short: "KN-659",
      name: "SAINT KITTS AND NEVIS",
      trade: "N"
    },
    {
      id: 192,
      short: "LC-662",
      name: "SAINT LUCIA",
      trade: "N"
    },
    {
      id: 193,
      short: "PM-666",
      name: "SAINT PIERRE MIQUELON",
      trade: "N"
    },
    {
      id: 194,
      short: "VC-670",
      name: "SAINT VINCENT",
      trade: "N"
    },
    {
      id: 195,
      short: "WS-882",
      name: "SAMOA",
      trade: "N"
    },
    {
      id: 196,
      short: "SM-674",
      name: "SAN MARINO",
      trade: "A"
    },
    {
      id: 197,
      short: "ST-678",
      name: "SAO TOME AND PRINCIPE",
      trade: "N"
    },
    {
      id: 198,
      short: "SA-682",
      name: "SAUDI ARABIA",
      trade: "N"

    },
    {
      id: 199,
      short: "SN-686",
      name: "SENEGAL",
      trade: "N"
    },
    {
      id: 200,
      short: "RS-688",
      name: "SERBIA",
      trade: "R"
    },
    {
      id: 201,
      short: "SC-690",
      name: "SEYCHELLES",
      trade: "N"
    },
    {
      id: 202,
      short: "XS-919",
      name: "SHARJAH",
      trade: "N"
    },
    {
      id: 203,
      short: "SL-694",
      name: "SIERRA LEONE",
      trade: "N"
    },
    {
      id: 204,
      short: "SG-702",
      name: "SINGAPORE",
      trade: "N"
    },
    {
      id: 205,
      short: "SX-534",
      name: "SINT MAARTEN (DUTCH PART)",
      trade: "N"
    },
    {
      id: 206,
      short: "SK-703",
      name: "SLOVAKIA",
      trade: "A"
    },
    {
      id: 207,
      short: "SI-705",
      name: "SLOVENIA",
      trade: "R"
    },
    {
      id: 208,
      short: "SB-90",
      name: "SOLOMON ISLANDS",
      trade: "A"
    },
    {
      id: 209,
      short: "SO-706",
      name: "SOMALIA",
      trade: "N"
    },
    {
      id: 210,
      short: "ZA-710",
      name: "SOUTH AFRICA",
      trade: "A"
    },
    {
      id: 211,
      short: "GS-984",
      name: "SOUTH GEORGIA",
      trade: "N"
    },
    {
      id: 212,
      short: "GS-986",
      name: "SOUTH SANDWICH ISLANDS",
      trade: "N"
    },
    {
      id: 213,
      short: "SS-728",
      name: "SOUTH SUDAN",
      trade: "N"
    },
    {
      id: 214,
      short: "ES-724",
      name: "SPAIN",
      trade: "A"
    },
    {
      id: 215,
      short: "LK-144",
      name: "SRI LANKA",
      trade: "N"
    },
    {
      id: 216,
      short: "SD-736",
      name: "SUDAN",
      trade: "N"
    },
    {
      id: 217,
      short: "SR-740",
      name: "SURINAME",
      trade: "N"
    },
    {
      id: 218,
      short: "SZ-748",
      name: "SWAZILAND",
      trade: "A"
    },
    {
      id: 219,
      short: "SE-752",
      name: "SWEDEN",
      trade: 'A'
    },
    {
      id: 220,
      short: "CH-756",
      name: "SWITZERLAND",
      trade: "A"
    },
    {
      id: 221,
      short: "SY-760",
      name: "SYRIA",
      trade: "N"
    },
    {
      id: 222,
      short: "TW-158",
      name: "TAIWAN",
      trade: "N"
    },
    {
      id: 223,
      short: "TJ-762",
      name: "TAJIKISTAN",
      trade: "R"
    },
    {
      id: 224,
      short: "TZ-834",
      name: "TANZANIA",
      trade: "N"
    },
    {
      id: 225,
      short: "TH-764",
      name: "THAILAND",
      trade: "N"
    },
    {
      id: 226,
      short: "TG-768",
      name: "TOGO",
      trade: "N"
    },
    {
      id: 227,
      short: "TK-772",
      name: "TOKELAU",
      trade: "A"
    },
    {
      id: 228,
      short: "TO-776",
      name: "TONGA",
      trade: "A"
    },
    {
      id: 229,
      short: "TT-780",
      name: "TRINIDAD AND TOBAGO",
      trade: "N"
    },
    {
      id: 230,
      short: "TN-788",
      name: "TUNISIA",
      trade: "N"
    },
    {
      id: 231,
      short: "TR-792",
      name: "TURKEY",
      trade: "N"
    },
    {
      id: 232,
      short: "XT-977",
      name: "TURKISH REPUBLIC OF NORTHERN CYPRUS",
      trade: "N"
    },
    {
      id: 233,
      short: "TM-795",
      name: "TURKMENISTAN",
      trade: "R"
    },
    {
      id: 234,
      short: "TC-796",
      name: "TURKS AND CAICOS ISLANDS",
      trade: "N"
    },
    {
      id: 235,
      short: "TV-798",
      name: "TUVALU",
      trade: "A"
    },
    {
      id: 236,
      short: "UG-800",
      name: "UGANDA",
      trade: "N"
    },
    {
      id: 237,
      short: "UA-804",
      name: "UKRAINE",
      trade: "R"
    },
    {
      id: 238,
      short: "XU-921",
      name: "UMM-AL-QUWAIN",
      trade: "N"
    },
    {
      id: 239,
      short: "AE-784",
      name: "UNITED ARAB EMIRATES",
      trade: "N"
    },
    {
      id: 240,
      short: "GB-826",
      name: "UNITED KINGDOM",
      trade: "A"
    },
    {
      id: 241,
      short: "UM-581",
      name: "UNITED STATES MINOR OUTLYING ISLANDS",
      trade: "R"
    },
    {
      id: 242,
      short: "US-840",
      name: "UNITED STATES OF AMERICA",
      trade: "R"
    },
    {
      id: 243,
      short: "UY-858",
      name: "URUGUAY",
      trade: "N"
    },
    {
      id: 244,
      short: "UZ-860",
      name: "UZBEKISTAN",
      trade: "R"
    },
    {
      id: 245,
      short: "VU-548",
      name: "VANUATU",
      trade: "A"
    },
    {
      id: 246,
      short: "VE-862",
      name: "VENEZUELA",
      trade: "N"
    },
    {
      id: 247,
      short: "VN-704",
      name: "VIETNAM",
      trade: "N"
    },
    {
      id: 248,
      short: "WK-931",
      name: "WAKE ISLAND",
      trade: "N"
    },
    {
      id: 249,
      short: "WF-876",
      name: "WALLIS AND FUTUNA ISLANDS",
      trade: "N"
    },
    {
      id: 250,
      short: "YE-887",
      name: "YEMEN",
      trade: "N"
    },
    {
      id: 251,
      short: "YU-891",
      name: "YUGOSLAVIA",
      trade: "N"
    },
    {
      id: 252,
      short: "ZM-894",
      name: "ZAMBIA",
      trade: "N"
    },
    {
      id: 253,
      short: "ZW-716",
      name: "ZIMBABWE",
      trade: "A"
    }
  ];
  reasons = [{
      id: 1,
      short: "1",
      name: "Credit Decision",
    },
    {
      id: 2,
      short: "2",
      name: "Credit Check - Intended Business Connection",
    },
    {
      id: 3,
      short: "3",
      name: "Credit Check - Ongoing Business Connection",
    },
    {
      id: 4,
      short: "4",
      name: "Debt Collection",
    },
    {
      id: 5,
      short: "5",
      name: "Commercial Credit Insurance",
    },
    {
      id: 6,
      short: "6",
      name: "Insurance Contract",
    },
    {
      id: 7,
      short: "7",
      name: "Leasing Agreement",
    },
    {
      id: 8,
      short: "8",
      name: "Rental Agreement",
    },
  ];
  province = [{
      id: 1,
      short: "AB",
      name: "Alberta",
    },
    {
      id: 2,
      short: "BC",
      name: "British columbia",
    },
    {
      id: 3,
      short: "MB",
      name: "Manitoba",
    },
    {
      id: 4,
      short: "NB",
      name: "New Brunswick",
    },
    {
      id: 5,
      short: "NL",
      name: "Newfoundland",
    },
    {
      id: 6,
      short: "NT",
      name: "Northwest Territories",
    },
    {
      id: 7,
      short: "NS",
      name: "Nova Scotia",
    },
    {
      id: 8,
      short: "NU",
      name: "Nunavut",
    },
    {
      id: 9,
      short: "ON",
      name: "Ontario",
    },
    {
      id: 10,
      short: "PE",
      name: "Prince Edward Island",
    },
    {
      id: 11,
      short: "QC",
      name: "Quabec",
    },
    {
      id: 12,
      short: "SK",
      name: "Saskatchewan",
    },
    {
      id: 13,
      short: "YT",
      name: "Yukon territory",
    }
  ];
  parseXML(xmlData) {
    var options = {
      attributeNamePrefix: "@_",
      attrNodeName: "attr", //default is 'false'
      textNodeName: "#text",
      ignoreAttributes: true,
      ignoreNameSpace: false,
      allowBooleanAttributes: false,
      parseNodeValue: true,
      parseAttributeValue: false,
      trimValues: true,
      cdataTagName: "__cdata", //default is 'false'
      cdataPositionChar: "\\c",
      parseTrueNumberOnly: true,
      arrayMode: false, //"strict"
      stopNodes: ["parse-me-as-string"]
    };
    try {
      var jsonObj = parse(xmlData, options);
    } catch (error) {
      //console.log(error.message);
    }
    return jsonObj;
  }
  beautify(text, format, preserveWS) {

    /*	@text  			- String, text to beautify;
     *	@format 		- String, 'xml' or 'json'
     * 	@preserveWS		- Bool (optional);
     *					  flag, which instruct application don't 
     *   				  remove extra white spaces within @text; 
     *
     *	Return - String
     *	
     * USAGE:
     *	
     *	beautify(text, 'xml'); 
     *	beautify(text, 'xml', true); 
     *	beautify(text, 'json'); 
     *	beautify(text, 'json', true); 
     *
     */
    var shift = ['\n'], // array of shifts
      deep = 0,
      str = '',
      jsonStr = '',
      step = '  ', // 2 spaces
      inComment = false,
      maxdeep = 100, // nesting level
      ix = 0,
      ar,
      len = 0;

    /* initialize array with shifts */
    for (ix = 0; ix < maxdeep; ix++) {
      shift.push(shift[ix] + step);
    }

    if (format == 'xml') {

      ar = preserveWS ? text.replace(/</g, "~#~<").split('~#~') :
        text.replace(/>\s{0,}</g, "><").replace(/</g, "~#~<").split('~#~');
      len = ar.length;

      for (ix = 0; ix < len; ix++) {
        /* start comment or <![CDATA[...]]> or <!DOCTYPE*/
        if (ar[ix].search(/<!/) > -1) {
          str += shift[deep] + ar[ix];
          inComment = true;
          /* end comment  or <![CDATA[...]]> */
          if (ar[ix].search(/-->/) > -1 || ar[ix].search(/\]>/) > -1 || ar[ix].search(/!DOCTYPE/) > -1) {
            inComment = false;
          }
        } else
          /* end comment  or <![CDATA[...]]> */
          if (ar[ix].search(/-->/) > -1 || ar[ix].search(/\]>/) > -1) {
            str += ar[ix];
            inComment = false;
          } else
            /* <elm></elm> */
            if (/^<\w/.exec(ar[ix - 1]) && /^<\/\w/.exec(ar[ix])
              /*&&
                         /^<\w+/.exec(ar[ix-1]) == /^<\/\w+/.exec(ar[ix])[0].replace('/','') */
            ) {
              str += ar[ix];
              if (!inComment) deep--;
            } else
              /* <elm> */
              if (ar[ix].search(/<\w/) > -1 && ar[ix].search(/<\//) == -1 && ar[ix].search(/\/>/) == -1) {
                str = !inComment ? str += shift[deep++] + ar[ix] : str += ar[ix];
              } else
                /* <elm>...</elm> */
                if (ar[ix].search(/<\w/) > -1 && ar[ix].search(/<\//) > -1) {
                  str = !inComment ? str += shift[deep] + ar[ix] : str += ar[ix];
                } else
                  /* </elm> */
                  if (ar[ix].search(/<\//) > -1) {
                    str = !inComment ? str += shift[--deep] + ar[ix] : str += ar[ix];
                  } else
                    /* <elm/> */
                    if (ar[ix].search(/\/>/) > -1) {
                      str = !inComment ? str += shift[deep] + ar[ix] : str += ar[ix];
                    } else
                      /* <? xml ... ?> */
                      if (ar[ix].search(/<\?/) > -1) {
                        str += shift[deep] + ar[ix];
                      } else {
                        str += ar[ix];
                      }
      }

      return (str[0] == '\n') ? str.slice(1) : str;

    }
  }
  getCurDate() {
    var year = this.date.getFullYear();
    var month = this.date.getMonth() + 1;
    var curmonth = month < 10 ? '0' + month : month;
    var date = this.date.getDate() < 10 ? '0' + this.date.getDate() : this.date.getDate();
    var hours = this.date.getHours() < 10 ? '0' + this.date.getHours() : this.date.getHours();
    var minutes = this.date.getMinutes() < 10 ? '0' + this.date.getMinutes() : this.date.getMinutes();
    var seconds = this.date.getSeconds() < 10 ? '0' + this.date.getSeconds() : this.date.getSeconds();
    return year + "-" + curmonth + "-" + date + " " + hours + ":" + minutes + ":" + seconds;
  }
  getCurDateOnly() {
    var year = this.date.getFullYear();
    var month = this.date.getMonth() + 1;
    var curmonth = month < 10 ? '0' + month : month;
    var date = this.date.getDate() < 10 ? '0' + this.date.getDate() : this.date.getDate();
    var hours = this.date.getHours() < 10 ? '0' + this.date.getHours() : this.date.getHours();
    var minutes = this.date.getMinutes() < 10 ? '0' + this.date.getMinutes() : this.date.getMinutes();
    var seconds = this.date.getSeconds() < 10 ? '0' + this.date.getSeconds() : this.date.getSeconds();
    return year + "-" + curmonth + "-" + date;
  }
  getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }
  getTRNUID() {
    this.trnuid = ((1000000000 * this.getRandomInt(1, 15) + 1).toString(16) + ((2000000 * this.getRandomInt(1, 15) + 1)).toString(16));
    return this.trnuid;
  }
  public selectModal(modalValue) {
    switch (modalValue) {
      case "ReasonCodeModal": {
        this.dialogBox['title'] = "Reason Code";
        this.dialogBox['content'] = "<TABLE BORDER='1' valign='top'><TR><TD><B>Value</B></TD><TD><B>Description</B></TD>\n" +
          "</TR><TR><TD>0</TD></TR><TR><TD>1</TD><TD>Credit decision</TD></TR>\n" +
          "<TR><TD>2</TD><TD>Credit check - intended bus. connection</TD></TR>\n" +
          "<TR><TD>3</TD><TD>Credit check - ongoing bus. connection</TD></TR>\n" +
          "<TR><TD>4</TD><TD>Debt collection</TD></TR>\n" +
          "<TR><TD>5</TD><TD>Commercial credit insurance</TD></TR>\n" +
          "<TR><TD>6</TD><TD>Insurance contract</TD></TR>\n" +
          "<TR><TD>7</TD><TD>Leasing agreement</TD></TR>\n" +
          "<TR><TD>8</TD><TD>Rental agreement</TD></TR></TABLE>";
        break;
      }
      case "CountryCodeModal": {
        this.dialogBox['title'] = "Country Code";
        this.dialogBox['content'] = "<TABLE BORDER='1' valign='top'><TR><TD><B>Value</B></TD><TD><B>Description</B></TD></TR><TR><TD>AD</TD><TD>Andorra</TD></TR><TR><TD>AE</TD><TD>United Arab Emirates</TD></TR><TR><TD>AF</TD><TD>Afghanistan</TD></TR><TR><TD>AG</TD><TD>Antigua and Barbuda</TD></TR><TR><TD>AI</TD><TD>Anguilla</TD></TR><TR><TD>AL</TD><TD>Albania</TD></TR><TR><TD>AM</TD><TD>Armenia</TD></TR><TR><TD>AN</TD><TD>Netherlands Antilles</TD></TR><TR><TD>AO</TD><TD>Angola</TD></TR><TR><TD>AQ</TD><TD>Antarctica</TD></TR><TR><TD>AR</TD><TD>Argentina</TD></TR><TR><TD>AS</TD><TD>American Samoa</TD></TR><TR><TD>AT</TD><TD>Austria</TD></TR><TR><TD>AU</TD><TD>Australia</TD></TR><TR><TD>AW</TD><TD>Aruba</TD></TR><TR><TD>AZ</TD><TD>Azerbaijan</TD></TR><TR><TD>BA</TD><TD>Bosnia and Herzegovina</TD></TR><TR><TD>BB</TD><TD>Barbados</TD></TR><TR><TD>BD</TD><TD>Bangladesh</TD></TR><TR><TD>BE</TD><TD>Belgium</TD></TR><TR><TD>BF</TD><TD>Burkina Faso</TD></TR><TR><TD>BG</TD><TD>Bulgaria</TD></TR><TR><TD>BH</TD><TD>Bahrain</TD></TR><TR><TD>BI</TD><TD>Burundi</TD></TR><TR><TD>BJ</TD><TD>Benin</TD></TR><TR><TD>BM</TD><TD>Bermuda</TD></TR><TR><TD>BN</TD><TD>Brunei Darussalam</TD></TR><TR><TD>BO</TD><TD>Bolivia</TD></TR><TR><TD>BR</TD><TD>Brazil</TD></TR><TR><TD>BS</TD><TD>Bahamas</TD></TR><TR><TD>BT</TD><TD>Bhutan</TD></TR><TR><TD>BW</TD><TD>Botswana</TD></TR><TR><TD>BY</TD><TD>Belarus</TD></TR><TR><TD>BZ</TD><TD>Belize</TD></TR><TR><TD>CA</TD><TD>Canada</TD></TR><TR><TD>CC</TD><TD>Cocos (Keeling) Islands</TD></TR><TR><TD>CD</TD><TD>Congo Democratic Republic</TD></TR><TR><TD>CF</TD><TD>Central African Republic</TD></TR><TR><TD>CG</TD><TD>Congo, Republic of</TD></TR><TR><TD>CH</TD><TD>Switzerland</TD></TR><TR><TD>CI</TD><TD>Cote d'Ivoire</TD></TR><TR><TD>CK</TD><TD>Cook Islands</TD></TR><TR><TD>CL</TD><TD>Chile</TD></TR><TR><TD>CM</TD><TD>Cameroon</TD></TR><TR><TD>CN</TD><TD>China</TD></TR><TR><TD>CO</TD><TD>Colombia</TD></TR><TR><TD>CR</TD><TD>Costa Rica</TD></TR><TR><TD>CS</TD><TD>Serbia and Montenegro</TD></TR><TR><TD>CU</TD><TD>Cuba</TD></TR><TR><TD>CV</TD><TD>Cape Verde</TD></TR><TR><TD>CX</TD><TD>Christmas Island</TD></TR><TR><TD>CY</TD><TD>Cyprus</TD></TR><TR><TD>CZ</TD><TD>Czech Republic</TD></TR><TR><TD>DE</TD><TD>Germany</TD></TR><TR><TD>DJ</TD><TD>Djibouti</TD></TR><TR><TD>DK</TD><TD>Denmark</TD></TR><TR><TD>DM</TD><TD>Dominica</TD></TR><TR><TD>DO</TD><TD>Dominican Republic</TD></TR><TR><TD>DZ</TD><TD>Algeria</TD></TR><TR><TD>EC</TD><TD>Ecuador</TD></TR><TR><TD>EE</TD><TD>Estonia</TD></TR><TR><TD>EG</TD><TD>Egypt</TD></TR><TR><TD>EH</TD><TD>Western Sahara</TD></TR><TR><TD>ER</TD><TD>Eritrea</TD></TR><TR><TD>ES</TD><TD>Spain</TD></TR><TR><TD>ET</TD><TD>Ethiopia</TD></TR><TR><TD>FI</TD><TD>Finland</TD></TR><TR><TD>FJ</TD><TD>Fiji</TD></TR><TR><TD>FK</TD><TD>Falkland Islands (Malvinas)</TD></TR><TR><TD>FM</TD><TD>Micronesia, Federated States of</TD></TR><TR><TD>FO</TD><TD>Faroe Islands</TD></TR><TR><TD>FR</TD><TD>France</TD></TR><TR><TD>GA</TD><TD>Gabon</TD></TR><TR><TD>GB</TD><TD>United Kingdom</TD></TR><TR><TD>GD</TD><TD>Grenada</TD></TR><TR><TD>GE</TD><TD>Georgia</TD></TR><TR><TD>GF</TD><TD>French Guiana</TD></TR><TR><TD>GH</TD><TD>Ghana</TD></TR><TR><TD>GI</TD><TD>Gibraltar</TD></TR><TR><TD>GL</TD><TD>Greenland</TD></TR><TR><TD>GM</TD><TD>Gambia</TD></TR><TR><TD>GN</TD><TD>Guinea</TD></TR><TR><TD>GP</TD><TD>Guadeloupe</TD></TR><TR><TD>GQ</TD><TD>Equatorial Guinea</TD></TR><TR><TD>GR</TD><TD>Greece</TD></TR><TR><TD>GS</TD><TD>SOUTH GEORGIA</TD></TR><TR><TD>GT</TD><TD>Guatemala</TD></TR><TR><TD>GU</TD><TD>Guam</TD></TR><TR><TD>GW</TD><TD>Guinea-Bissau</TD></TR><TR><TD>GY</TD><TD>Guyana</TD></TR><TR><TD>HK</TD><TD>Hong Kong</TD></TR><TR><TD>HN</TD><TD>Honduras</TD></TR><TR><TD>HR</TD><TD>Croatia</TD></TR><TR><TD>HT</TD><TD>Haiti</TD></TR><TR><TD>HU</TD><TD>Hungary</TD></TR><TR><TD>ID</TD><TD>Indonesia</TD></TR><TR><TD>IE</TD><TD>Ireland</TD></TR><TR><TD>IL</TD><TD>Israel</TD></TR><TR><TD>IN</TD><TD>India</TD></TR><TR><TD>IQ</TD><TD>Iraq</TD></TR><TR><TD>IR</TD><TD>IRAN</TD></TR><TR><TD>IS</TD><TD>Iceland</TD></TR><TR><TD>IT</TD><TD>Italy</TD></TR><TR><TD>JM</TD><TD>Jamaica</TD></TR><TR><TD>JO</TD><TD>Jordan</TD></TR><TR><TD>JP</TD><TD>Japan</TD></TR><TR><TD>KE</TD><TD>Kenya</TD></TR><TR><TD>KG</TD><TD>Kyrgyzstan</TD></TR><TR><TD>KH</TD><TD>Kampuchea (Cambodia)</TD></TR><TR><TD>KI</TD><TD>Kiribati</TD></TR><TR><TD>KM</TD><TD>Comoros</TD></TR><TR><TD>KN</TD><TD>Saint Kitts and Nevis</TD></TR><TR><TD>KP</TD><TD>Korea, Democratic People's Republic of</TD></TR><TR><TD>KR</TD><TD>Korea</TD></TR><TR><TD>KW</TD><TD>Kuwait</TD></TR><TR><TD>KY</TD><TD>Cayman Islands</TD></TR><TR><TD>KZ</TD><TD>Kazakstan</TD></TR><TR><TD>LA</TD><TD>Lao, People's Democratic Republic</TD></TR><TR><TD>LB</TD><TD>Lebanon</TD></TR><TR><TD>LC</TD><TD>Saint Lucia</TD></TR><TR><TD>LI</TD><TD>Liechtenstein</TD></TR><TR><TD>LK</TD><TD>Sri Lanka</TD></TR><TR><TD>LR</TD><TD>Liberia</TD></TR><TR><TD>LS</TD><TD>Lesotho</TD></TR><TR><TD>LT</TD><TD>Lithuania</TD></TR><TR><TD>LU</TD><TD>Luxembourg</TD></TR><TR><TD>LV</TD><TD>Latvia</TD></TR><TR><TD>LY</TD><TD>Libyan Arab Jamahiriya</TD></TR><TR><TD>MA</TD><TD>Morocco</TD></TR><TR><TD>MC</TD><TD>Monaco</TD></TR><TR><TD>MD</TD><TD>Moldova</TD></TR><TR><TD>ME</TD><TD>Montenegro</TD></TR><TR><TD>MG</TD><TD>Madagascar</TD></TR><TR><TD>MH</TD><TD>Marshall Islands</TD></TR><TR><TD>MK</TD><TD>Macedonia, The Former Yugoslav Republic Of</TD></TR><TR><TD>ML</TD><TD>Mali</TD></TR><TR><TD>MM</TD><TD>Myanmar</TD></TR><TR><TD>MO</TD><TD>Macao</TD></TR><TR><TD>MP</TD><TD>Northern Mariana Islands</TD></TR><TR><TD>MQ</TD><TD>Martinique</TD></TR><TR><TD>MR</TD><TD>Mauritania</TD></TR><TR><TD>MS</TD><TD>Montserrat</TD></TR><TR><TD>MT</TD><TD>Malta</TD></TR><TR><TD>MU</TD><TD>Mauritius</TD></TR><TR><TD>MV</TD><TD>Maldives</TD></TR><TR><TD>MW</TD><TD>Malawi</TD></TR><TR><TD>MX</TD><TD>Mexico</TD></TR><TR><TD>MY</TD><TD>Malaysia</TD></TR><TR><TD>MZ</TD><TD>Mozambique</TD></TR><TR><TD>NA</TD><TD>Namibia</TD></TR><TR><TD>NE</TD><TD>Niger</TD></TR><TR><TD>NF</TD><TD>Norfolk Island</TD></TR><TR><TD>NG</TD><TD>Nigeria</TD></TR><TR><TD>NI</TD><TD>Nicaragua</TD></TR><TR><TD>NL</TD><TD>Netherlands</TD></TR><TR><TD>NO</TD><TD>Norway</TD></TR><TR><TD>NP</TD><TD>Nepal</TD></TR><TR><TD>NR</TD><TD>Nauru</TD></TR><TR><TD>NT</TD><TD>Neutral Zone</TD></TR><TR><TD>NU</TD><TD>Niue</TD></TR><TR><TD>NZ</TD><TD>New Zealand</TD></TR><TR><TD>OM</TD><TD>Oman</TD></TR><TR><TD>PA</TD><TD>Panama</TD></TR><TR><TD>PE</TD><TD>Peru</TD></TR><TR><TD>PF</TD><TD>French Polynesia</TD></TR><TR><TD>PG</TD><TD>Papua New Guinea</TD></TR><TR><TD>PH</TD><TD>Philippines</TD></TR><TR><TD>PK</TD><TD>Pakistan</TD></TR><TR><TD>PL</TD><TD>Poland</TD></TR><TR><TD>PM</TD><TD>Saint Pierre and Miquelon</TD></TR><TR><TD>PN</TD><TD>Pitcairn</TD></TR><TR><TD>PT</TD><TD>Portugal</TD></TR><TR><TD>PW</TD><TD>Palau</TD></TR><TR><TD>PY</TD><TD>Paraguay</TD></TR><TR><TD>QA</TD><TD>Qatar</TD></TR><TR><TD>RO</TD><TD>Romania</TD></TR><TR><TD>RS</TD><TD>Serbia</TD></TR><TR><TD>RU</TD><TD>Russia Federation</TD></TR><TR><TD>RW</TD><TD>Rwanda</TD></TR><TR><TD>SA</TD><TD>Saudi Arabia</TD></TR><TR><TD>SB</TD><TD>Solomon Islands</TD></TR><TR><TD>SC</TD><TD>Seychelles</TD></TR><TR><TD>SD</TD><TD>Sudan</TD></TR><TR><TD>SE</TD><TD>Sweden</TD></TR><TR><TD>SJ</TD><TD>Svalbard and Jan Mayen</TD></TR><TR><TD>SG</TD><TD>Singapore</TD></TR><TR><TD>SH</TD><TD>Saint Helena</TD></TR><TR><TD>SI</TD><TD>Slovenia</TD></TR><TR><TD>SK</TD><TD>Slovakia</TD></TR><TR><TD>SL</TD><TD>Sierra Leone</TD></TR><TR><TD>SM</TD><TD>San Marino</TD></TR><TR><TD>SN</TD><TD>Senegal</TD></TR><TR><TD>SO</TD><TD>Somalia</TD></TR><TR><TD>SR</TD><TD>Suriname</TD></TR><TR><TD>ST</TD><TD>Sao Tome and Principe</TD></TR><TR><TD>SV</TD><TD>El Salvador</TD></TR><TR><TD>SY</TD><TD>Syrian Arab Republic</TD></TR><TR><TD>SZ</TD><TD>Swaziland</TD></TR><TR><TD>TC</TD><TD>Turks and Caicos Islands</TD></TR><TR><TD>TD</TD><TD>Chad</TD></TR><TR><TD>TF</TD><TD>French Southern Territories</TD></TR><TR><TD>TG</TD><TD>Togo</TD></TR><TR><TD>TH</TD><TD>Thailand</TD></TR><TR><TD>TJ</TD><TD>Tajikistan</TD></TR><TR><TD>TK</TD><TD>Tokelau</TD></TR><TR><TD>TL</TD><TD>Timor-Leste</TD></TR><TR><TD>TM</TD><TD>Turkmenistan</TD></TR><TR><TD>TN</TD><TD>Tunisia</TD></TR><TR><TD>TO</TD><TD>Tonga</TD></TR><TR><TD>TR</TD><TD>Turkey</TD></TR><TR><TD>TT</TD><TD>Trinidad and Tobago</TD></TR><TR><TD>TV</TD><TD>Tuvalu</TD></TR><TR><TD>TW</TD><TD>Taiwan</TD></TR><TR><TD>TZ</TD><TD>Tanzania, United Republic of</TD></TR><TR><TD>UA</TD><TD>Ukraine</TD></TR><TR><TD>UG</TD><TD>Uganda</TD></TR><TR><TD>UM</TD><TD>United States Minor Outlying Islands</TD></TR><TR><TD>US</TD><TD>United States</TD></TR><TR><TD>UY</TD><TD>Uruguay</TD></TR><TR><TD>UZ</TD><TD>Uzbekistan</TD></TR><TR><TD>VC</TD><TD>Saint Vincent & the Grenadines</TD></TR><TR><TD>VE</TD><TD>Venezuela</TD></TR><TR><TD>VG</TD><TD>BRITISH VIRGIN ISLANDS</TD></TR><TR><TD>VN</TD><TD>VIETNAM</TD></TR><TR><TD>VU</TD><TD>Vanuatu</TD></TR><TR><TD>WS</TD><TD>Samoa</TD></TR><TR><TD>XB</TD><TD>Turkish Republic of Northern Cyprus</TD></TR><TR><TD>YD</TD><TD>Yemen, Democratic</TD></TR><TR><TD>YE</TD><TD>Yemen</TD></TR><TR><TD>ZA</TD><TD>SOUTH AFRICA</TD></TR><TR><TD>ZM</TD><TD>Zambia</TD></TR><TR><TD>ZW</TD><TD>Zimbabwe</TD></TR></TABLE>";
        break;
      }
      case "MatchTypeModal": {
        this.dialogBox['title'] = "Match Type";
        this.dialogBox['content'] = "<TABLE BORDER=1 valign=top><TR><TD><B>Value</B></TD><TD><B>Description</B></TD></TR><TR><TD>N</TD><TD>No confidence</TD></TR><TR><TD>C</TD><TD>Confidence</TD></TR></TABLE>";
        break;
      }
      case "ListOrderStateModal": {
        this.dialogBox['title'] = "List Order State";
        this.dialogBox['content'] = "<TABLE BORDER=1 valign=top><TR><TD><B>Value</B></TD><TD><B>Description</B></TD></TR><TR><TD>0</TD><TD>Order has been Created</TD></TR><TR><TD>1</TD><TD>Order has been Fulfilled</TD></TR><TR><TD>2</TD><TD>Order has been ReadByCustomer</TD></TR><TR><TD>3</TD><TD>Order has been ReadByRequestor</TD></TR><TR><TD>null</TD></TR></TABLE>";
        break;
      }
      case "UserLevelModal": {
        this.dialogBox['title'] = "User Level";
        this.dialogBox['content'] = "<TABLE BORDER=1 valign=top><TR><TD><B>Value</B></TD><TD><B>Description</B></TD></TR><TR><TD>null</TD></TR><TR><TD>1</TD><TD>D&B Super User</TD></TR><TR><TD>2</TD><TD>Global Contract Administrator</TD></TR><TR><TD>3</TD><TD>Group Administrator</TD></TR><TR><TD>4</TD><TD>Data Integration Toolkit users</TD></TR></TABLE>";
        break;
      }
      case "ProductModal": {
        this.dialogBox['title'] = "Product";
        this.dialogBox['content'] = "<TABLE BORDER=1 valign=top><TR><TD><B>Value</B></TD><TD><B>Description</B></TD></TR><TR><TD>Business Verification</TD><TD>Business Verification - verifies a company's existence and validate its location</TD></TR><TR><TD>European Preview</TD><TD>European Preview</TD></TR><TR><TD>European Business Data</TD><TD>European Business Data</TD></TR><TR><TD>European Business Data Plus</TD><TD>European Business Data Plus</TD></TR><TR><TD>GACustomProduct[1-12]</TD><TD>Customers defined products based on selected GDA data packets:  GACustomProduct1, GACustomProduct2, GACustomProduct3, GACustomProduct4, GACustomProduct5, GACustomProduct6, GACustomProduct7, GACustomProduct8, GACustomProduct9,GACustomProduct10,GACustomProduct12</TD></TR><TR><TD>Decision Support</TD><TD>Decision Support - improves the timeliness and consistency of credit decisions</TD></TR><TR><TD>Delinquency Score</TD><TD>Delinquency Score - improves the accuracy of credit decisions and collections policies and techniques by accessing predictive information on the likelihood of a company exhibiting payment delinquency over the next 12 months</TD></TR><TR><TD>DTRi Summary</TD><TD>DTRi Summary - Detailed Trade Risk Insight provides granular, monthly trade details on more that 1.5 billion commercial trade experiences from over 260 million supplier/purchaser relationships. The database will contain a monthly time series of trade payment behavior. D and B will have the most comprehensive payment and  open balance database on the market</TD></TR><TR><TD>Emerging Market Mediation Alert Score</TD><TD>Emerging Market Mediation Alert Score</TD></TR><TR><TD>Enterprise Management</TD><TD>Enterprise Management - retrieves comprehensive business and financial information ready for implementation into ERP or other proprietary system</TD></TR><TR><TD>Family Tree - Basic</TD><TD>Family Tree - Basic :  determines family members of a business to help uncover new selling opportunities, negotiate global purchasing agreements and perform merger and market analysis.</TD></TR><TR><TD>Family Tree - Enhanced</TD><TD>Family Tree - Enhanced: identifies worldwide family members with more detailed information on each business</TD></TR><TR><TD>Financial Standing</TD><TD>Financial Standing - assesses a company's financial strength with data such as sales volumes, net worth, assets and liabilities</TD></TR><TR><TD>GDM</TD><TD>D and B Global DecisionMaker - implements a globally consistent risk management policy by setting your own decision rules which use D and B data to deliver almost instant decisions that meet your determined level of risk</TD></TR><TR><TD>GDM PLUS</TD><TD>D and B Global DecisionMaker Plus - as above, delivers your decision, together with all of the D and B data used in fabricating the decision, including the D and B Credit (Delinquency) Score Aggregate, the D and B Failure Score Aggregate, the D and B PAYDEX and/or the D and B Rating.</TD></TR><TR><TD>Quick Check</TD><TD>Quick Check- performs low risk credit assessments and pre-screen prospects with DnB's core credit evaluation data</TD></TR><TR><TD>Vendor Management</TD><TD>Vendor Management -  helps ensure the stability and efficiency of supply chain with detailed business information on suppliers such as headquarters and parent company identification</TD></TR><TR><TD>WorldBase Marketing ID</TD><TD>WorldBase Marketing ID - delivers basic marketing information about a potential prospect such as business name, address, D and B® D-U-N-S® Number, fax, phone and trade style.</TD></TR><TR><TD>WorldBase Marketing Plus</TD><TD>WorldBase Marketing Plus - delivers same information included in D and B WorldBase Marketing ID plus business intelligence such as executive names and titles, financials, number of employees, import or export code, branch indicator, and more.</TD></TR><TR><TD>WorldBase Marketing Plus with Linkage</TD><TD>WorldBase Marketing Plus with Linkage - delivers same information included in D and B WorldBase Marketing Plus, with the addition of corporate family relationships.</TD></TR><TR><TD>Compact Report</TD><TD>Compact Report - provides three years financial comparisons, D and B Rating and a 'maximum credit recommendation' as a guide in setting credit limits.</TD></TR><TR><TD>Comprehensive Report</TD><TD>Comprehensive Report</TD></TR><TR><TD>D and B Business Information Report</TD><TD>D and B Business Information Report - performs critical analysis of a firm’s operations, profitability and stability based on detailed financial and business information.  D and B Comprehensive Report delves deeper into a company’s history and performance to analyse critically its characteristics as a business partner</TD></TR><TR><TD>Small Business Risk Insight Detail</TD><TD>Small Business Risk Insight Detail</TD></TR><TR><TD>Small Business Risk Insight Detail Plus</TD><TD>Small Business Risk Insight Detail Plus</TD></TR><TR><TD>USP29</TD><TD>USP29 - Rating, Previous Rating and Indicators</TD></TR><TR><TD>USP50</TD><TD>USP50 - Principal Information</TD></TR><TR><TD>USP65</TD><TD>USP65 - UCC</TD></TR><TR><TD>USP79</TD><TD>USP79 - Payment Summary</TD></TR><TR><TD>USPDL</TD><TD>USPDL - Organization Structure</TD></TR><TR><TD>USPIC</TD><TD>USPIC - Commercial Credit Score</TD></TR><TR><TD>USPIJ</TD><TD>USPIJ - Commercial Credit Score</TD></TR><TR><TD>USPFY</TD><TD>USPFY - Financial Stress Score</TD></TR><TR><TD>USP85</TD><TD>USP85 - Lien - BIR Rules</TD></TR><TR><TD>USP86</TD><TD>USP86 - Judgment - BIR Rules</TD></TR><TR><TD>USP87</TD><TD>USP87 - Suit - BIR Rules</TD></TR><TR><TD>USP88</TD><TD>USP88 - Business Classification</TD></TR><TR><TD>USPTD</TD><TD>USPTD - DTRI Score Online</TD></TR><TR><TD>USP89</TD><TD>USP89 - Public Record Summary</TD></TR><TR><TD>Small Business Risk New Account Score</TD><TD>Small Business Risk New Account Score</TD></TR><TR><TD>GDM Small Business Risk New Account Score</TD><TD>GDM Small Business Risk New Account Score</TD></TR><TR><TD>USA Patriot Act Compliance</TD><TD>USA Patriot Act Compliance</TD></TR><TR><TD>USA Patriot Act Compliance Plus</TD><TD>USA Patriot Act Compliance Plus</TD></TR><TR><TD>USP80</TD><TD>USP80 - Payment Detailed Summary</TD></TR><TR><TD>CAP99+ - RAM Plus</TD><TD>Canadian Enhanced eRAM</TD></TR><TR><TD>CAP99 - RAM Standard</TD><TD>Canadian Basic eRAM</TD></TR><TR><TD>Corporate Linkage</TD><TD>Corporate Linkage</TD></TR><TR><TD>Global Product for eRAM</TD><TD>Global Product for eRAM</TD></TR><TR><TD>USP Financials - 3 Years</TD><TD>USP Financials - 3 Years</TD></TR><TR><TD>USPEE - RAM Standard</TD><TD>USPEE - RAM Standard</TD></TR><TR><TD>USPEF - RAM Plus</TD><TD>USPEF - RAM Plus</TD></TR><TR><TD>USPEP - Financial Stress for eRAM</TD><TD>USPEP - Financial Stress for eRAM</TD></TR><TR><TD>Business Information Summary</TD><TD>Business Information Summary</TD></TR><TR><TD>BIR - ID and Summary</TD><TD>BIR - ID and Summary</TD></TR><TR><TD>BIR - Finance</TD><TD>BIR - Finance</TD></TR><TR><TD>BIR - Banking</TD><TD>BIR - Banking</TD></TR><TR><TD>BIR - Public Filings</TD><TD>BIR - Public Filings</TD></TR><TR><TD>BIR - Payments</TD><TD>BIR - Payments</TD></TR><TR><TD>BIR - History and Operations</TD><TD>BIR - History and Operations</TD></TR><TR><TD>BIR - Spec Events/Changes/Upds</TD><TD>BIR - Spec Events/Changes/Upds</TD></TR><TR><TD>PAR - ID and Summary</TD><TD>PAR - ID and Summary</TD></TR><TR><TD>PAR - Summry of Pymnt Habits</TD><TD>PAR - Summry of Pymnt Habits</TD></TR><TR><TD>PAR - Pymnt Habits by Indsty</TD><TD>PAR - Pymnt Habits by Indsty</TD></TR><TR><TD>USPPR</TD><TD>USPPR - Public Records Super Packet</TD></TR><TR><TD>Public Record Search</TD><TD>Public Record Filing Search</TD></TR><TR><TD>Public Record Filing List</TD><TD>Public Record Filing List</TD></TR><TR><TD>US Tax Identification Number</TD><TD>US Tax Identification Number</TD></TR><TR><TD>US Corporate Linkage</TD><TD>US Corporate Linkage</TD></TR><TR><TD>Private Company Insight</TD><TD>Private Company Insight</TD></TR><TR><TD>US Industry Classification</TD><TD>US Industry Classification</TD></TR><TR><TD>USP46</TD><TD>USP46 - Provides details of the legal structure and filing requirements of a business. Information includes; type of organisation, address of registration, date of incorporation, registered name, capital and stock details.</TD></TR><TR><TD>Payment Analysis Report</TD><TD>Payment Analysis Report</TD></TR><TR><TD>Business Background Report</TD><TD>Business Background Report</TD></TR><TR><TD>eBIR</TD><TD>eBIR</TD></TR><TR><TD>CAP Financials - 3 Years</TD><TD>CAP Financials - 3 Years</TD></TR><TR><TD>Vendor Qualification</TD><TD>Vendor Qualification</TD></TR><TR><TD>Vendor Qualification with Linkage</TD><TD>Vendor Qualification with Linkage</TD></TR><TR><TD>Vendor Qualification with Diversity</TD><TD>Vendor Qualification with Diversity</TD></TR><TR><TD>null</TD></TR></TABLE>";
        break;
      }
      case "OrderByModal": {
        this.dialogBox['title'] = "Order By";
        this.dialogBox['content'] = "<TABLE BORDER=1 valign=top><TR><TD><B>Value</B></TD><TD><B>Description</B></TD></TR><TR><TD>DUNS_NBR</TD><TD>Duns Number</TD></TR><TR><TD>PRIM_NME</TD><TD>Business Name</TD></TR><TR><TD>PROD</TD><TD>Product Code</TD></TR><TR><TD>ORDR_DT</TD><TD>Order Date</TD></TR></TABLE>";
        break;
      }
      case "SortOrderModal": {
        this.dialogBox['title'] = "Sort Order";
        this.dialogBox['content'] = "<TABLE BORDER=1 valign=top><TR><TD><B>Value</B></TD><TD><B>Description</B></TD></TR><TR><TD>ASC</TD><TD>order by ascending</TD></TR><TR><TD>DESC</TD><TD>order by descending</TD></TR></TABLE>";
        break;
      }
      case "CharacterSetOverrideModal": {
        this.dialogBox['title'] = "Character Set Override";
        this.dialogBox['content'] = "<TABLE BORDER=1 valign=top><TR><TD><B>Value</B></TD><TD><B>Description</B></TD></TR><TR><TD>US-ASCII</TD><TD>US-ASCII</TD></TR><TR><TD>ISO-8859-1</TD><TD>ISO-8859-1</TD></TR></TABLE>";
        break;
      }
      case "SearchStatesModal": {
        this.dialogBox['title'] = "Search States";
        this.dialogBox['content'] = "<Table border=1 valign=top><TR><TD>Comma seperated values of states</TD></TR></Table><BR><Table border=1 valign=top><TR><TD><B>Value</B></TD><TD><B>Description</B></TD></TR><TR><TD>AK</TD><TD>Alaska</TD></TR><TR><TD>ak</TD><TD>Alaska</TD></TR><TR><TD>AL</TD><TD>Alabama</TD></TR><TR><TD>al</TD><TD>Alabama</TD></TR><TR><TD>AR</TD><TD>Arkansas</TD></TR><TR><TD>ar</TD><TD>Arkansas</TD></TR><TR><TD>AZ</TD><TD>Arizona</TD></TR><TR><TD>az</TD><TD>Arizona</TD></TR><TR><TD>CA</TD><TD>California</TD></TR><TR><TD>ca</TD><TD>California</TD></TR><TR><TD>CO</TD><TD>Colorado</TD></TR><TR><TD>co</TD><TD>Colorado</TD></TR><TR><TD>CT</TD><TD>Connecticut</TD></TR><TR><TD>ct</TD><TD>Connecticut</TD></TR><TR><TD>DC</TD><TD>District of Columbia</TD></TR><TR><TD>dc</TD><TD>District of Columbia</TD></TR><TR><TD>DE</TD><TD>Delaware</TD></TR><TR><TD>de</TD><TD>Delaware</TD></TR><TR><TD>FL</TD><TD>Florida</TD></TR><TR><TD>fl</TD><TD>Florida</TD></TR><TR><TD>GA</TD><TD>Georgia</TD></TR><TR><TD>ga</TD><TD>Georgia</TD></TR><TR><TD>HI</TD><TD>Hawaii</TD></TR><TR><TD>hi</TD><TD>Hawaii</TD></TR><TR><TD>IA</TD><TD>Iowa</TD></TR><TR><TD>ia</TD><TD>Iowa</TD></TR><TR><TD>ID</TD><TD>Idaho</TD></TR><TR><TD>id</TD><TD>Idaho</TD></TR><TR><TD>IL</TD><TD>Illinois</TD></TR><TR><TD>il</TD><TD>Illinois</TD></TR><TR><TD>IN</TD><TD>Indiana</TD></TR><TR><TD>in</TD><TD>Indiana</TD></TR><TR><TD>KS</TD><TD>Kansas</TD></TR><TR><TD>ks</TD><TD>Kansas</TD></TR><TR><TD>KY</TD><TD>Kentucky</TD></TR><TR><TD>ky</TD><TD>Kentucky</TD></TR><TR><TD>LA</TD><TD>Louisiana</TD></TR><TR><TD>la</TD><TD>Louisiana</TD></TR><TR><TD>MA</TD><TD>Massachusetts</TD></TR><TR><TD>ma</TD><TD>Massachusetts</TD></TR><TR><TD>MD</TD><TD>Maryland</TD></TR><TR><TD>md</TD><TD>Maryland</TD></TR><TR><TD>ME</TD><TD>Maine</TD></TR><TR><TD>me</TD><TD>Maine</TD></TR><TR><TD>MI</TD><TD>Michigan</TD></TR><TR><TD>mi</TD><TD>Michigan</TD></TR><TR><TD>MN</TD><TD>Minnesota</TD></TR><TR><TD>mn</TD><TD>Minnesota</TD></TR><TR><TD>MO</TD><TD>Missouri</TD></TR><TR><TD>mo</TD><TD>Missouri</TD></TR><TR><TD>MS</TD><TD>Mississippi</TD></TR><TR><TD>ms</TD><TD>Mississippi</TD></TR><TR><TD>MT</TD><TD>Montana</TD></TR><TR><TD>mt</TD><TD>Montana</TD></TR><TR><TD>NC</TD><TD>North Carolina</TD></TR><TR><TD>nc</TD><TD>North Carolina</TD></TR><TR><TD>ND</TD><TD>North Dakota</TD></TR><TR><TD>nd</TD><TD>North Dakota</TD></TR><TR><TD>NE</TD><TD>Nebraska</TD></TR><TR><TD>ne</TD><TD>Nebraska</TD></TR><TR><TD>NH</TD><TD>New Hampshire</TD></TR><TR><TD>nh</TD><TD>New Hampshire</TD></TR><TR><TD>NJ</TD><TD>New Jersey</TD></TR><TR><TD>nj</TD><TD>New Jersey</TD></TR><TR><TD>NM</TD><TD>New Mexico</TD></TR><TR><TD>nm</TD><TD>New Mexico</TD></TR><TR><TD>NV</TD><TD>Nevada</TD></TR><TR><TD>nv</TD><TD>Nevada</TD></TR><TR><TD>NY</TD><TD>New York</TD></TR><TR><TD>ny</TD><TD>New York</TD></TR><TR><TD>OH</TD><TD>Ohio</TD></TR><TR><TD>oh</TD><TD>Ohio</TD></TR><TR><TD>OK</TD><TD>Oklahama</TD></TR><TR><TD>ok</TD><TD>Oklahama</TD></TR><TR><TD>OR</TD><TD>Oregon</TD></TR><TR><TD>or</TD><TD>Oregon</TD></TR><TR><TD>PA</TD><TD>Pennsylvania</TD></TR><TR><TD>pa</TD><TD>Pennsylvania</TD></TR><TR><TD>PR</TD><TD>Puerto Rico</TD></TR><TR><TD>pr</TD><TD>Puerto Rico</TD></TR><TR><TD>RI</TD><TD>Rhode Island</TD></TR><TR><TD>ri</TD><TD>Rhode Island</TD></TR><TR><TD>SC</TD><TD>South Carolina</TD></TR><TR><TD>sc</TD><TD>South Carolina</TD></TR><TR><TD>SD</TD><TD>South Dakota</TD></TR><TR><TD>sd</TD><TD>South Dakota</TD></TR><TR><TD>TN</TD><TD>Tennessee</TD></TR><TR><TD>tn</TD><TD>Tennessee</TD></TR><TR><TD>TX</TD><TD>Texas</TD></TR><TR><TD>tx</TD><TD>Texas</TD></TR><TR><TD>UT</TD><TD>Utah</TD></TR><TR><TD>ut</TD><TD>Utah</TD></TR><TR><TD>VA</TD><TD>Virginia</TD></TR><TR><TD>va</TD><TD>Virginia</TD></TR><TR><TD>VI</TD><TD>Virgin Islands</TD></TR><TR><TD>vi</TD><TD>Virgin Islands</TD></TR><TR><TD>VT</TD><TD>Vermont</TD></TR><TR><TD>vt</TD><TD>Vermont</TD></TR><TR><TD>WA</TD><TD>Washington</TD></TR><TR><TD>wa</TD><TD>Washington</TD></TR><TR><TD>WI</TD><TD>West Virginia</TD></TR><TR><TD>wi</TD><TD>West Virginia</TD></TR><TR><TD>WV</TD><TD>Wisconsin</TD></TR><TR><TD>wv</TD><TD>Wisconsin</TD></TR><TR><TD>WY</TD><TD>Wyoming</TD></TR><TR><TD>wy</TD><TD>Wyoming</TD></TR></Table>";
        break;
      }
      case "KeyReportStateModal": {
        this.dialogBox['title'] = "Key Report State";
        this.dialogBox['content'] = "<TABLE BORDER=1 valign=top><TR><TD><B>Value</B></TD><TD><B>Description</B></TD></TR><TR><TD>AK</TD><TD>Alaska</TD></TR><TR><TD>ak</TD><TD>Alaska</TD></TR><TR><TD>AL</TD><TD>Alabama</TD></TR><TR><TD>al</TD><TD>Alabama</TD></TR><TR><TD>AR</TD><TD>Arkansas</TD></TR><TR><TD>ar</TD><TD>Arkansas</TD></TR><TR><TD>AZ</TD><TD>Arizona</TD></TR><TR><TD>az</TD><TD>Arizona</TD></TR><TR><TD>CA</TD><TD>California</TD></TR><TR><TD>ca</TD><TD>California</TD></TR><TR><TD>CO</TD><TD>Colorado</TD></TR><TR><TD>co</TD><TD>Colorado</TD></TR><TR><TD>CT</TD><TD>Connecticut</TD></TR><TR><TD>ct</TD><TD>Connecticut</TD></TR><TR><TD>DC</TD><TD>District of Columbia</TD></TR><TR><TD>dc</TD><TD>District of Columbia</TD></TR><TR><TD>DE</TD><TD>Delaware</TD></TR><TR><TD>de</TD><TD>Delaware</TD></TR><TR><TD>FL</TD><TD>Florida</TD></TR><TR><TD>fl</TD><TD>Florida</TD></TR><TR><TD>GA</TD><TD>Georgia</TD></TR><TR><TD>ga</TD><TD>Georgia</TD></TR><TR><TD>HI</TD><TD>Hawaii</TD></TR><TR><TD>hi</TD><TD>Hawaii</TD></TR><TR><TD>IA</TD><TD>Iowa</TD></TR><TR><TD>ia</TD><TD>Iowa</TD></TR><TR><TD>ID</TD><TD>Idaho</TD></TR><TR><TD>id</TD><TD>Idaho</TD></TR><TR><TD>IL</TD><TD>Illinois</TD></TR><TR><TD>il</TD><TD>Illinois</TD></TR><TR><TD>IN</TD><TD>Indiana</TD></TR><TR><TD>in</TD><TD>Indiana</TD></TR><TR><TD>KS</TD><TD>Kansas</TD></TR><TR><TD>ks</TD><TD>Kansas</TD></TR><TR><TD>KY</TD><TD>Kentucky</TD></TR><TR><TD>ky</TD><TD>Kentucky</TD></TR><TR><TD>LA</TD><TD>Louisiana</TD></TR><TR><TD>la</TD><TD>Louisiana</TD></TR><TR><TD>MA</TD><TD>Massachusetts</TD></TR><TR><TD>ma</TD><TD>Massachusetts</TD></TR><TR><TD>MD</TD><TD>Maryland</TD></TR><TR><TD>md</TD><TD>Maryland</TD></TR><TR><TD>ME</TD><TD>Maine</TD></TR><TR><TD>me</TD><TD>Maine</TD></TR><TR><TD>MI</TD><TD>Michigan</TD></TR><TR><TD>mi</TD><TD>Michigan</TD></TR><TR><TD>MN</TD><TD>Minnesota</TD></TR><TR><TD>mn</TD><TD>Minnesota</TD></TR><TR><TD>MO</TD><TD>Missouri</TD></TR><TR><TD>mo</TD><TD>Missouri</TD></TR><TR><TD>MS</TD><TD>Mississippi</TD></TR><TR><TD>ms</TD><TD>Mississippi</TD></TR><TR><TD>MT</TD><TD>Montana</TD></TR><TR><TD>mt</TD><TD>Montana</TD></TR><TR><TD>NC</TD><TD>North Carolina</TD></TR><TR><TD>nc</TD><TD>North Carolina</TD></TR><TR><TD>ND</TD><TD>North Dakota</TD></TR><TR><TD>nd</TD><TD>North Dakota</TD></TR><TR><TD>NE</TD><TD>Nebraska</TD></TR><TR><TD>ne</TD><TD>Nebraska</TD></TR><TR><TD>NH</TD><TD>New Hampshire</TD></TR><TR><TD>nh</TD><TD>New Hampshire</TD></TR><TR><TD>NJ</TD><TD>New Jersey</TD></TR><TR><TD>nj</TD><TD>New Jersey</TD></TR><TR><TD>NM</TD><TD>New Mexico</TD></TR><TR><TD>nm</TD><TD>New Mexico</TD></TR><TR><TD>NV</TD><TD>Nevada</TD></TR><TR><TD>nv</TD><TD>Nevada</TD></TR><TR><TD>NY</TD><TD>New York</TD></TR><TR><TD>ny</TD><TD>New York</TD></TR><TR><TD>OH</TD><TD>Ohio</TD></TR><TR><TD>oh</TD><TD>Ohio</TD></TR><TR><TD>OK</TD><TD>Oklahama</TD></TR><TR><TD>ok</TD><TD>Oklahama</TD></TR><TR><TD>OR</TD><TD>Oregon</TD></TR><TR><TD>or</TD><TD>Oregon</TD></TR><TR><TD>PA</TD><TD>Pennsylvania</TD></TR><TR><TD>pa</TD><TD>Pennsylvania</TD></TR><TR><TD>PR</TD><TD>Puerto Rico</TD></TR><TR><TD>pr</TD><TD>Puerto Rico</TD></TR><TR><TD>RI</TD><TD>Rhode Island</TD></TR><TR><TD>ri</TD><TD>Rhode Island</TD></TR><TR><TD>SC</TD><TD>South Carolina</TD></TR><TR><TD>sc</TD><TD>South Carolina</TD></TR><TR><TD>SD</TD><TD>South Dakota</TD></TR><TR><TD>sd</TD><TD>South Dakota</TD></TR><TR><TD>TN</TD><TD>Tennessee</TD></TR><TR><TD>tn</TD><TD>Tennessee</TD></TR><TR><TD>TX</TD><TD>Texas</TD></TR><TR><TD>tx</TD><TD>Texas</TD></TR><TR><TD>UT</TD><TD>Utah</TD></TR><TR><TD>ut</TD><TD>Utah</TD></TR><TR><TD>VA</TD><TD>Virginia</TD></TR><TR><TD>va</TD><TD>Virginia</TD></TR><TR><TD>VI</TD><TD>Virgin Islands, U.S.</TD></TR><TR><TD>vi</TD><TD>Virgin Islands, U.S.</TD></TR><TR><TD>VT</TD><TD>Vermont</TD></TR><TR><TD>vt</TD><TD>Vermont</TD></TR><TR><TD>WA</TD><TD>Washington</TD></TR><TR><TD>wa</TD><TD>Washington</TD></TR><TR><TD>WI</TD><TD>West Virginia</TD></TR><TR><TD>wi</TD><TD>West Virginia</TD></TR><TR><TD>WV</TD><TD>Wisconsin</TD></TR><TR><TD>wv</TD><TD>Wisconsin</TD></TR><TR><TD>WY</TD><TD>Wyoming</TD></TR><TR><TD>wy</TD><TD>Wyoming</TD></TR></TABLE>";
        break;
      }
      case "SearchDirectionModal": {
        this.dialogBox['title'] = "Search Direction";
        this.dialogBox['content'] = "<TABLE BORDER=1 valign=top><TR><TD><B>Value</B></TD><TD><B>Description</B></TD></TR><TR><TD>N</TD><TD>Next(Forward Direction)</TD></TR><TR><TD>n</TD><TD>Next(Forward Direction)</TD></TR><TR><TD>P</TD><TD>Prior(Backward Direction)</TD></TR><TR><TD>p</TD><TD>Prior(Backward Direction)</TD></TR><TR><TD>null</TD></TR></TABLE>";
        break;
      }
      case "RolePlayerModal": {
        this.dialogBox['title'] = "Role Player";
        this.dialogBox['content'] = "<TABLE BORDER=1 valign=top><TR><TD><B>Value</B></TD><TD><B>Description</B></TD></TR><TR><TD>D</TD><TD>Debtor, Defendant, Bankruptcy Subject</TD></TR><TR><TD>d</TD><TD>Debtor, Defendant, Bankruptcy Subject</TD></TR><TR><TD>C</TD><TD>Creditor, Plaintiff, Secured Party or Assignee, Lien Holder</TD></TR><TR><TD>c</TD><TD>Creditor, Plaintiff, Secured Party or Assignee, Lien Holder</TD></TR><TR><TD>E</TD><TD>Either</TD></TR><TR><TD>e</TD><TD>Either</TD></TR><TR><TD>null</TD></TR></TABLE>";
        break;
      }
      case "RegistrationsModal": {
        this.dialogBox['title'] = "Registrations";
        this.dialogBox['content'] = "<Table border=1 valign=top><TR><TD><B>Value</B></TD><TD><B>Description</B></TD></TR><TR><TD>Y</TD><TD>Yes</TD></TR><TR><TD>y</TD><TD>Yes</TD></TR><TR><TD>N</TD><TD>No</TD></TR><TR><TD>n</TD><TD>No</TD></TR></Table>";
        break;
      }
      case "UserLanguageModal": {

        this.dialogBox['title'] = "User Language";
        this.dialogBox['content'] = "<TABLE BORDER=1 valign=top><TR><TD><B>Value</B></TD><TD><B>Description</B></TD></TR><TR><TD>EN</TD><TD>English</TD></TR><TR><TD>en</TD></TR><TR><TD>FR</TD><TD>French</TD></TR><TR><TD>fr</TD></TR><TR><TD>GE</TD><TD>German</TD></TR><TR><TD>ge</TD></TR><TR><TD>SP</TD><TD>Spanish</TD></TR><TR><TD>sp</TD></TR><TR><TD>PO</TD><TD>Portuguese</TD></TR><TR><TD>po</TD></TR><TR><TD>IT</TD><TD>Italian</TD></TR><TR><TD>it</TD></TR><TR><TD>DU</TD><TD>Dutch</TD></TR><TR><TD>du</TD></TR></TABLE>";
        break;
      }
      case "CountryCodeModal": {
        this.dialogBox['title'] = "Country Code";
        this.dialogBox['content'] = "<TABLE BORDER=1 valign=top><TR><TD><B>Value</B></TD><TD><B>Description</B></TD></TR><TR><TD>AD</TD><TD>Andorra</TD></TR><TR><TD>AE</TD><TD>United Arab Emirates</TD></TR><TR><TD>AF</TD><TD>Afghanistan</TD></TR><TR><TD>AG</TD><TD>Antigua and Barbuda</TD></TR><TR><TD>AI</TD><TD>Anguilla</TD></TR><TR><TD>AL</TD><TD>Albania</TD></TR><TR><TD>AM</TD><TD>Armenia</TD></TR><TR><TD>AN</TD><TD>Netherlands Antilles</TD></TR><TR><TD>AO</TD><TD>Angola</TD></TR><TR><TD>AQ</TD><TD>Antarctica</TD></TR><TR><TD>AR</TD><TD>Argentina</TD></TR><TR><TD>AS</TD><TD>American Samoa</TD></TR><TR><TD>AT</TD><TD>Austria</TD></TR><TR><TD>AU</TD><TD>Australia</TD></TR><TR><TD>AW</TD><TD>Aruba</TD></TR><TR><TD>AZ</TD><TD>Azerbaijan</TD></TR><TR><TD>BA</TD><TD>Bosnia and Herzegovina</TD></TR><TR><TD>BB</TD><TD>Barbados</TD></TR><TR><TD>BD</TD><TD>Bangladesh</TD></TR><TR><TD>BE</TD><TD>Belgium</TD></TR><TR><TD>BF</TD><TD>Burkina Faso</TD></TR><TR><TD>BG</TD><TD>Bulgaria</TD></TR><TR><TD>BH</TD><TD>Bahrain</TD></TR><TR><TD>BI</TD><TD>Burundi</TD></TR><TR><TD>BJ</TD><TD>Benin</TD></TR><TR><TD>BM</TD><TD>Bermuda</TD></TR><TR><TD>BN</TD><TD>Brunei Darussalam</TD></TR><TR><TD>BO</TD><TD>Bolivia</TD></TR><TR><TD>BR</TD><TD>Brazil</TD></TR><TR><TD>BS</TD><TD>Bahamas</TD></TR><TR><TD>BT</TD><TD>Bhutan</TD></TR><TR><TD>BW</TD><TD>Botswana</TD></TR><TR><TD>BY</TD><TD>Belarus</TD></TR><TR><TD>BZ</TD><TD>Belize</TD></TR><TR><TD>CA</TD><TD>Canada</TD></TR><TR><TD>CC</TD><TD>Cocos (Keeling) Islands</TD></TR><TR><TD>CD</TD><TD>Congo Democratic Republic</TD></TR><TR><TD>CF</TD><TD>Central African Republic</TD></TR><TR><TD>CG</TD><TD>Congo, Republic of</TD></TR><TR><TD>CH</TD><TD>Switzerland</TD></TR><TR><TD>CI</TD><TD>Cote d'Ivoire</TD></TR><TR><TD>CK</TD><TD>Cook Islands</TD></TR><TR><TD>CL</TD><TD>Chile</TD></TR><TR><TD>CM</TD><TD>Cameroon</TD></TR><TR><TD>CN</TD><TD>China</TD></TR><TR><TD>CO</TD><TD>Colombia</TD></TR><TR><TD>CR</TD><TD>Costa Rica</TD></TR><TR><TD>CS</TD><TD>Serbia and Montenegro</TD></TR><TR><TD>CU</TD><TD>Cuba</TD></TR><TR><TD>CV</TD><TD>Cape Verde</TD></TR><TR><TD>CX</TD><TD>Christmas Island</TD></TR><TR><TD>CY</TD><TD>Cyprus</TD></TR><TR><TD>CZ</TD><TD>Czech Republic</TD></TR><TR><TD>DE</TD><TD>Germany</TD></TR><TR><TD>DJ</TD><TD>Djibouti</TD></TR><TR><TD>DK</TD><TD>Denmark</TD></TR><TR><TD>DM</TD><TD>Dominica</TD></TR><TR><TD>DO</TD><TD>Dominican Republic</TD></TR><TR><TD>DZ</TD><TD>Algeria</TD></TR><TR><TD>EC</TD><TD>Ecuador</TD></TR><TR><TD>EE</TD><TD>Estonia</TD></TR><TR><TD>EG</TD><TD>Egypt</TD></TR><TR><TD>EH</TD><TD>Western Sahara</TD></TR><TR><TD>ER</TD><TD>Eritrea</TD></TR><TR><TD>ES</TD><TD>Spain</TD></TR><TR><TD>ET</TD><TD>Ethiopia</TD></TR><TR><TD>FI</TD><TD>Finland</TD></TR><TR><TD>FJ</TD><TD>Fiji</TD></TR><TR><TD>FK</TD><TD>Falkland Islands (Malvinas)</TD></TR><TR><TD>FM</TD><TD>Micronesia, Federated States of</TD></TR><TR><TD>FO</TD><TD>Faroe Islands</TD></TR><TR><TD>FR</TD><TD>France</TD></TR><TR><TD>GA</TD><TD>Gabon</TD></TR><TR><TD>GB</TD><TD>United Kingdom</TD></TR><TR><TD>GD</TD><TD>Grenada</TD></TR><TR><TD>GE</TD><TD>Georgia</TD></TR><TR><TD>GF</TD><TD>French Guiana</TD></TR><TR><TD>GH</TD><TD>Ghana</TD></TR><TR><TD>GI</TD><TD>Gibraltar</TD></TR><TR><TD>GL</TD><TD>Greenland</TD></TR><TR><TD>GM</TD><TD>Gambia</TD></TR><TR><TD>GN</TD><TD>Guinea</TD></TR><TR><TD>GP</TD><TD>Guadeloupe</TD></TR><TR><TD>GQ</TD><TD>Equatorial Guinea</TD></TR><TR><TD>GR</TD><TD>Greece</TD></TR><TR><TD>GS</TD><TD>SOUTH GEORGIA</TD></TR><TR><TD>GT</TD><TD>Guatemala</TD></TR><TR><TD>GU</TD><TD>Guam</TD></TR><TR><TD>GW</TD><TD>Guinea-Bissau</TD></TR><TR><TD>GY</TD><TD>Guyana</TD></TR><TR><TD>HK</TD><TD>Hong Kong</TD></TR><TR><TD>HN</TD><TD>Honduras</TD></TR><TR><TD>HR</TD><TD>Croatia</TD></TR><TR><TD>HT</TD><TD>Haiti</TD></TR><TR><TD>HU</TD><TD>Hungary</TD></TR><TR><TD>ID</TD><TD>Indonesia</TD></TR><TR><TD>IE</TD><TD>Ireland</TD></TR><TR><TD>IL</TD><TD>Israel</TD></TR><TR><TD>IN</TD><TD>India</TD></TR><TR><TD>IQ</TD><TD>Iraq</TD></TR><TR><TD>IR</TD><TD>IRAN</TD></TR><TR><TD>IS</TD><TD>Iceland</TD></TR><TR><TD>IT</TD><TD>Italy</TD></TR><TR><TD>JM</TD><TD>Jamaica</TD></TR><TR><TD>JO</TD><TD>Jordan</TD></TR><TR><TD>JP</TD><TD>Japan</TD></TR><TR><TD>KE</TD><TD>Kenya</TD></TR><TR><TD>KG</TD><TD>Kyrgyzstan</TD></TR><TR><TD>KH</TD><TD>Kampuchea (Cambodia)</TD></TR><TR><TD>KI</TD><TD>Kiribati</TD></TR><TR><TD>KM</TD><TD>Comoros</TD></TR><TR><TD>KN</TD><TD>Saint Kitts and Nevis</TD></TR><TR><TD>KP</TD><TD>Korea, Democratic People's Republic of</TD></TR><TR><TD>KR</TD><TD>Korea</TD></TR><TR><TD>KW</TD><TD>Kuwait</TD></TR><TR><TD>KY</TD><TD>Cayman Islands</TD></TR><TR><TD>KZ</TD><TD>Kazakstan</TD></TR><TR><TD>LA</TD><TD>Lao, People's Democratic Republic</TD></TR><TR><TD>LB</TD><TD>Lebanon</TD></TR><TR><TD>LC</TD><TD>Saint Lucia</TD></TR><TR><TD>LI</TD><TD>Liechtenstein</TD></TR><TR><TD>LK</TD><TD>Sri Lanka</TD></TR><TR><TD>LR</TD><TD>Liberia</TD></TR><TR><TD>LS</TD><TD>Lesotho</TD></TR><TR><TD>LT</TD><TD>Lithuania</TD></TR><TR><TD>LU</TD><TD>Luxembourg</TD></TR><TR><TD>LV</TD><TD>Latvia</TD></TR><TR><TD>LY</TD><TD>Libyan Arab Jamahiriya</TD></TR><TR><TD>MA</TD><TD>Morocco</TD></TR><TR><TD>MC</TD><TD>Monaco</TD></TR><TR><TD>MD</TD><TD>Moldova</TD></TR><TR><TD>ME</TD><TD>Montenegro</TD></TR><TR><TD>MG</TD><TD>Madagascar</TD></TR><TR><TD>MH</TD><TD>Marshall Islands</TD></TR><TR><TD>MK</TD><TD>Macedonia, The Former Yugoslav Republic Of</TD></TR><TR><TD>ML</TD><TD>Mali</TD></TR><TR><TD>MM</TD><TD>Myanmar</TD></TR><TR><TD>MO</TD><TD>Macao</TD></TR><TR><TD>MP</TD><TD>Northern Mariana Islands</TD></TR><TR><TD>MQ</TD><TD>Martinique</TD></TR><TR><TD>MR</TD><TD>Mauritania</TD></TR><TR><TD>MS</TD><TD>Montserrat</TD></TR><TR><TD>MT</TD><TD>Malta</TD></TR><TR><TD>MU</TD><TD>Mauritius</TD></TR><TR><TD>MV</TD><TD>Maldives</TD></TR><TR><TD>MW</TD><TD>Malawi</TD></TR><TR><TD>MX</TD><TD>Mexico</TD></TR><TR><TD>MY</TD><TD>Malaysia</TD></TR><TR><TD>MZ</TD><TD>Mozambique</TD></TR><TR><TD>NA</TD><TD>Namibia</TD></TR><TR><TD>NE</TD><TD>Niger</TD></TR><TR><TD>NF</TD><TD>Norfolk Island</TD></TR><TR><TD>NG</TD><TD>Nigeria</TD></TR><TR><TD>NI</TD><TD>Nicaragua</TD></TR><TR><TD>NL</TD><TD>Netherlands</TD></TR><TR><TD>NO</TD><TD>Norway</TD></TR><TR><TD>NP</TD><TD>Nepal</TD></TR><TR><TD>NR</TD><TD>Nauru</TD></TR><TR><TD>NT</TD><TD>Neutral Zone</TD></TR><TR><TD>NU</TD><TD>Niue</TD></TR><TR><TD>NZ</TD><TD>New Zealand</TD></TR><TR><TD>OM</TD><TD>Oman</TD></TR><TR><TD>PA</TD><TD>Panama</TD></TR><TR><TD>PE</TD><TD>Peru</TD></TR><TR><TD>PF</TD><TD>French Polynesia</TD></TR><TR><TD>PG</TD><TD>Papua New Guinea</TD></TR><TR><TD>PH</TD><TD>Philippines</TD></TR><TR><TD>PK</TD><TD>Pakistan</TD></TR><TR><TD>PL</TD><TD>Poland</TD></TR><TR><TD>PM</TD><TD>Saint Pierre and Miquelon</TD></TR><TR><TD>PN</TD><TD>Pitcairn</TD></TR><TR><TD>PT</TD><TD>Portugal</TD></TR><TR><TD>PW</TD><TD>Palau</TD></TR><TR><TD>PY</TD><TD>Paraguay</TD></TR><TR><TD>QA</TD><TD>Qatar</TD></TR><TR><TD>RO</TD><TD>Romania</TD></TR><TR><TD>RS</TD><TD>Serbia</TD></TR><TR><TD>RU</TD><TD>Russia Federation</TD></TR><TR><TD>RW</TD><TD>Rwanda</TD></TR><TR><TD>SA</TD><TD>Saudi Arabia</TD></TR><TR><TD>SB</TD><TD>Solomon Islands</TD></TR><TR><TD>SC</TD><TD>Seychelles</TD></TR><TR><TD>SD</TD><TD>Sudan</TD></TR><TR><TD>SE</TD><TD>Sweden</TD></TR><TR><TD>SJ</TD><TD>Svalbard and Jan Mayen</TD></TR><TR><TD>SG</TD><TD>Singapore</TD></TR><TR><TD>SH</TD><TD>Saint Helena</TD></TR><TR><TD>SI</TD><TD>Slovenia</TD></TR><TR><TD>SK</TD><TD>Slovakia</TD></TR><TR><TD>SL</TD><TD>Sierra Leone</TD></TR><TR><TD>SM</TD><TD>San Marino</TD></TR><TR><TD>SN</TD><TD>Senegal</TD></TR><TR><TD>SO</TD><TD>Somalia</TD></TR><TR><TD>SR</TD><TD>Suriname</TD></TR><TR><TD>ST</TD><TD>Sao Tome and Principe</TD></TR><TR><TD>SV</TD><TD>El Salvador</TD></TR><TR><TD>SY</TD><TD>Syrian Arab Republic</TD></TR><TR><TD>SZ</TD><TD>Swaziland</TD></TR><TR><TD>TC</TD><TD>Turks and Caicos Islands</TD></TR><TR><TD>TD</TD><TD>Chad</TD></TR><TR><TD>TF</TD><TD>French Southern Territories</TD></TR><TR><TD>TG</TD><TD>Togo</TD></TR><TR><TD>TH</TD><TD>Thailand</TD></TR><TR><TD>TJ</TD><TD>Tajikistan</TD></TR><TR><TD>TK</TD><TD>Tokelau</TD></TR><TR><TD>TL</TD><TD>Timor-Leste</TD></TR><TR><TD>TM</TD><TD>Turkmenistan</TD></TR><TR><TD>TN</TD><TD>Tunisia</TD></TR><TR><TD>TO</TD><TD>Tonga</TD></TR><TR><TD>TR</TD><TD>Turkey</TD></TR><TR><TD>TT</TD><TD>Trinidad and Tobago</TD></TR><TR><TD>TV</TD><TD>Tuvalu</TD></TR><TR><TD>TW</TD><TD>Taiwan</TD></TR><TR><TD>TZ</TD><TD>Tanzania, United Republic of</TD></TR><TR><TD>UA</TD><TD>Ukraine</TD></TR><TR><TD>UG</TD><TD>Uganda</TD></TR><TR><TD>UM</TD><TD>United States Minor Outlying Islands</TD></TR><TR><TD>US</TD><TD>United States</TD></TR><TR><TD>UY</TD><TD>Uruguay</TD></TR><TR><TD>UZ</TD><TD>Uzbekistan</TD></TR><TR><TD>VC</TD><TD>Saint Vincent & the Grenadines</TD></TR><TR><TD>VE</TD><TD>Venezuela</TD></TR><TR><TD>VG</TD><TD>BRITISH VIRGIN ISLANDS</TD></TR><TR><TD>VN</TD><TD>VIETNAM</TD></TR><TR><TD>VU</TD><TD>Vanuatu</TD></TR><TR><TD>WS</TD><TD>Samoa</TD></TR><TR><TD>XB</TD><TD>Turkish Republic of Northern Cyprus</TD></TR><TR><TD>YD</TD><TD>Yemen, Democratic</TD></TR><TR><TD>YE</TD><TD>Yemen</TD></TR><TR><TD>ZA</TD><TD>SOUTH AFRICA</TD></TR><TR><TD>ZM</TD><TD>Zambia</TD></TR><TR><TD>ZW</TD><TD>Zimbabwe</TD></TR></TABLE>";
        break;
      }
      case "ActionModal": {
        this.dialogBox['title'] = "Action";
        this.dialogBox['content'] = "<TABLE BORDER=1 valign=top><TR><TD><B>Value</B></TD><TD><B>Description</B></TD></TR><TR><TD>GET</TD><TD>retrieve preference.</TD></TR><TR><TD>SET</TD><TD>update preference</TD></TR></TABLE>";
        break;
      }
      case "TradeupIndicatorModal": {
        this.dialogBox['title'] = "Trade up Indicator";
        this.dialogBox['content'] = "<TABLE BORDER=1 valign=top><TR><TD><B>Value</B></TD><TD><B>Description</B></TD></TR><TR><TD>Y</TD><TD>Yes</TD></TR><TR><TD>y</TD><TD>Yes</TD></TR><TR><TD>N</TD><TD>No</TD></TR><TR><TD>n</TD><TD>No</TD></TR></TABLE>";
        break;
      }
      case "ProductModal": {
        this.dialogBox['title'] = "Product";
        this.dialogBox['content'] = "<TABLE BORDER=1 valign=top><TR><TD><B>Value</B></TD><TD><B>Description</B></TD></TR><TR><TD>Business Verification</TD><TD>Business Verification - verifies a company's existence and validate its location</TD></TR><TR><TD>European Preview</TD><TD>European Preview</TD></TR><TR><TD>European Business Data</TD><TD>European Business Data</TD></TR><TR><TD>European Business Data Plus</TD><TD>European Business Data Plus</TD></TR><TR><TD>GACustomProduct[1-12]</TD><TD>Customers defined products based on selected GDA data packets:  GACustomProduct1, GACustomProduct2, GACustomProduct3, GACustomProduct4, GACustomProduct5, GACustomProduct6, GACustomProduct7, GACustomProduct8, GACustomProduct9,GACustomProduct10,GACustomProduct12</TD></TR><TR><TD>Decision Support</TD><TD>Decision Support - improves the timeliness and consistency of credit decisions</TD></TR><TR><TD>Delinquency Score</TD><TD>Delinquency Score - improves the accuracy of credit decisions and collections policies and techniques by accessing predictive information on the likelihood of a company exhibiting payment delinquency over the next 12 months</TD></TR><TR><TD>DTRi Summary</TD><TD>DTRi Summary - Detailed Trade Risk Insight provides granular, monthly trade details on more that 1.5 billion commercial trade experiences from over 260 million supplier/purchaser relationships. The database will contain a monthly time series of trade payment behavior. D and B will have the most comprehensive payment and  open balance database on the market</TD></TR><TR><TD>Emerging Market Mediation Alert Score</TD><TD>Emerging Market Mediation Alert Score</TD></TR><TR><TD>Enterprise Management</TD><TD>Enterprise Management - retrieves comprehensive business and financial information ready for implementation into ERP or other proprietary system</TD></TR><TR><TD>Family Tree - Basic</TD><TD>Family Tree - Basic :  determines family members of a business to help uncover new selling opportunities, negotiate global purchasing agreements and perform merger and market analysis.</TD></TR><TR><TD>Family Tree - Enhanced</TD><TD>Family Tree - Enhanced: identifies worldwide family members with more detailed information on each business</TD></TR><TR><TD>Financial Standing</TD><TD>Financial Standing - assesses a company's financial strength with data such as sales volumes, net worth, assets and liabilities</TD></TR><TR><TD>GDM</TD><TD>D and B Global DecisionMaker - implements a globally consistent risk management policy by setting your own decision rules which use D and B data to deliver almost instant decisions that meet your determined level of risk</TD></TR><TR><TD>GDM PLUS</TD><TD>D and B Global DecisionMaker Plus - as above, delivers your decision, together with all of the D and B data used in fabricating the decision, including the D and B Credit (Delinquency) Score Aggregate, the D and B Failure Score Aggregate, the D and B PAYDEX and/or the D and B Rating.</TD></TR><TR><TD>Quick Check</TD><TD>Quick Check- performs low risk credit assessments and pre-screen prospects with DnB's core credit evaluation data</TD></TR><TR><TD>Vendor Management</TD><TD>Vendor Management -  helps ensure the stability and efficiency of supply chain with detailed business information on suppliers such as headquarters and parent company identification</TD></TR><TR><TD>WorldBase Marketing ID</TD><TD>WorldBase Marketing ID - delivers basic marketing information about a potential prospect such as business name, address, D and B® D-U-N-S® Number, fax, phone and trade style.</TD></TR><TR><TD>WorldBase Marketing Plus</TD><TD>WorldBase Marketing Plus - delivers same information included in D and B WorldBase Marketing ID plus business intelligence such as executive names and titles, financials, number of employees, import or export code, branch indicator, and more.</TD></TR><TR><TD>WorldBase Marketing Plus with Linkage</TD><TD>WorldBase Marketing Plus with Linkage - delivers same information included in D and B WorldBase Marketing Plus, with the addition of corporate family relationships.</TD></TR><TR><TD>Compact Report</TD><TD>Compact Report - provides three years financial comparisons, D and B Rating and a 'maximum credit recommendation' as a guide in setting credit limits.</TD></TR><TR><TD>Comprehensive Report</TD><TD>Comprehensive Report</TD></TR><TR><TD>D and B Business Information Report</TD><TD>D and B Business Information Report - performs critical analysis of a firm’s operations, profitability and stability based on detailed financial and business information.  D and B Comprehensive Report delves deeper into a company’s history and performance to analyse critically its characteristics as a business partner</TD></TR><TR><TD>Small Business Risk Insight Detail</TD><TD>Small Business Risk Insight Detail</TD></TR><TR><TD>Small Business Risk Insight Detail Plus</TD><TD>Small Business Risk Insight Detail Plus</TD></TR><TR><TD>USP29</TD><TD>USP29 - Rating, Previous Rating and Indicators</TD></TR><TR><TD>USP50</TD><TD>USP50 - Principal Information</TD></TR><TR><TD>USP65</TD><TD>USP65 - UCC</TD></TR><TR><TD>USP79</TD><TD>USP79 - Payment Summary</TD></TR><TR><TD>USPDL</TD><TD>USPDL - Organization Structure</TD></TR><TR><TD>USPIC</TD><TD>USPIC - Commercial Credit Score</TD></TR><TR><TD>USPIJ</TD><TD>USPIJ - Commercial Credit Score</TD></TR><TR><TD>USPFY</TD><TD>USPFY - Financial Stress Score</TD></TR><TR><TD>USP85</TD><TD>USP85 - Lien - BIR Rules</TD></TR><TR><TD>USP86</TD><TD>USP86 - Judgment - BIR Rules</TD></TR><TR><TD>USP87</TD><TD>USP87 - Suit - BIR Rules</TD></TR><TR><TD>USP88</TD><TD>USP88 - Business Classification</TD></TR><TR><TD>USPTD</TD><TD>USPTD - DTRI Score Online</TD></TR><TR><TD>USP89</TD><TD>USP89 - Public Record Summary</TD></TR><TR><TD>Small Business Risk New Account Score</TD><TD>Small Business Risk New Account Score</TD></TR><TR><TD>GDM Small Business Risk New Account Score</TD><TD>GDM Small Business Risk New Account Score</TD></TR><TR><TD>USA Patriot Act Compliance</TD><TD>USA Patriot Act Compliance</TD></TR><TR><TD>USA Patriot Act Compliance Plus</TD><TD>USA Patriot Act Compliance Plus</TD></TR><TR><TD>USP80</TD><TD>USP80 - Payment Detailed Summary</TD></TR><TR><TD>CAP99+ - RAM Plus</TD><TD>Canadian Enhanced eRAM</TD></TR><TR><TD>CAP99 - RAM Standard</TD><TD>Canadian Basic eRAM</TD></TR><TR><TD>Corporate Linkage</TD><TD>Corporate Linkage</TD></TR><TR><TD>Global Product for eRAM</TD><TD>Global Product for eRAM</TD></TR><TR><TD>USP Financials - 3 Years</TD><TD>USP Financials - 3 Years</TD></TR><TR><TD>USPEE - RAM Standard</TD><TD>USPEE - RAM Standard</TD></TR><TR><TD>USPEF - RAM Plus</TD><TD>USPEF - RAM Plus</TD></TR><TR><TD>USPEP - Financial Stress for eRAM</TD><TD>USPEP - Financial Stress for eRAM</TD></TR><TR><TD>Business Information Summary</TD><TD>Business Information Summary</TD></TR><TR><TD>BIR - ID and Summary</TD><TD>BIR - ID and Summary</TD></TR><TR><TD>BIR - Finance</TD><TD>BIR - Finance</TD></TR><TR><TD>BIR - Banking</TD><TD>BIR - Banking</TD></TR><TR><TD>BIR - Public Filings</TD><TD>BIR - Public Filings</TD></TR><TR><TD>BIR - Payments</TD><TD>BIR - Payments</TD></TR><TR><TD>BIR - History and Operations</TD><TD>BIR - History and Operations</TD></TR><TR><TD>BIR - Spec Events/Changes/Upds</TD><TD>BIR - Spec Events/Changes/Upds</TD></TR><TR><TD>PAR - ID and Summary</TD><TD>PAR - ID and Summary</TD></TR><TR><TD>PAR - Summry of Pymnt Habits</TD><TD>PAR - Summry of Pymnt Habits</TD></TR><TR><TD>PAR - Pymnt Habits by Indsty</TD><TD>PAR - Pymnt Habits by Indsty</TD></TR><TR><TD>USPPR</TD><TD>USPPR - Public Records Super Packet</TD></TR><TR><TD>Public Record Search</TD><TD>Public Record Filing Search</TD></TR><TR><TD>Public Record Filing List</TD><TD>Public Record Filing List</TD></TR><TR><TD>US Tax Identification Number</TD><TD>US Tax Identification Number</TD></TR><TR><TD>US Corporate Linkage</TD><TD>US Corporate Linkage</TD></TR><TR><TD>Private Company Insight</TD><TD>Private Company Insight</TD></TR><TR><TD>US Industry Classification</TD><TD>US Industry Classification</TD></TR><TR><TD>USP46</TD><TD>USP46 - Provides details of the legal structure and filing requirements of a business. Information includes; type of organisation, address of registration, date of incorporation, registered name, capital and stock details.</TD></TR><TR><TD>Payment Analysis Report</TD><TD>Payment Analysis Report</TD></TR><TR><TD>Business Background Report</TD><TD>Business Background Report</TD></TR><TR><TD>eBIR</TD><TD>eBIR</TD></TR><TR><TD>CAP Financials - 3 Years</TD><TD>CAP Financials - 3 Years</TD></TR><TR><TD>Vendor Qualification</TD><TD>Vendor Qualification</TD></TR><TR><TD>Vendor Qualification with Linkage</TD><TD>Vendor Qualification with Linkage</TD></TR><TR><TD>Vendor Qualification with Diversity</TD><TD>Vendor Qualification with Diversity</TD></TR></TABLE>";
        break;
      }
      case "ProductTypeModal": {
        this.dialogBox['title'] = "Product Type";
        this.dialogBox['content'] = "<TABLE BORDER=1 valign=top><TR><TD><B>Value</B></TD><TD><B>Description</B></TD></TR><TR><TD>D</TD><TD>Data Sheet Products include: Business Demographics and Summary, Business Identification, Business Verification, Corporate Structure, Decision Support, Delinquency Score, Enterprise Management, Evaluation, Family Tree - Basic, Family Tree - Enhanced, Financial Standing, Financials, GDM, GDM PLUS, Global Failure Risk Score, Quick Check, Significant Event Indicators, Vendor Management, WorldBase Marketing ID, WorldBase Marketing Plus, WorldBase Marketing Plus with Linkage</TD></TR><TR><TD>d</TD></TR><TR><TD>T</TD><TD>Text Sheet Products include: Compact Report, Comprehensive Report, D and B Business Information Report, Supplier Evaluation Report -</TD></TR><TR><TD>t</TD></TR><TR><TD>L</TD><TD>Local Products include: D and B Commercial Credit Score (USA)</TD></TR><TR><TD>l</TD></TR><TR><TD>X</TD><TD>Fabricated Products</TD></TR><TR><TD>x</TD></TR></TABLE>";
        break;
      }
      case "ReasonCodeModal": {
        this.dialogBox['title'] = "Reason Code";
        this.dialogBox['content'] = "<TABLE BORDER=1 valign=top><TR><TD><B>Value</B></TD><TD><B>Description</B></TD></TR><TR><TD>0</TD></TR><TR><TD>1</TD><TD>Credit decision</TD></TR><TR><TD>2</TD><TD>Credit check - intended bus. connection</TD></TR><TR><TD>3</TD><TD>Credit check - ongoing bus. connection</TD></TR><TR><TD>4</TD><TD>Debt collection</TD></TR><TR><TD>5</TD><TD>Commercial credit insurance</TD></TR><TR><TD>6</TD><TD>Insurance contract</TD></TR><TR><TD>7</TD><TD>Leasing agreement</TD></TR><TR><TD>8</TD><TD>Rental agreement</TD></TR></TABLE> ";
        break;

      }

      case "CountryModal": {
        this.dialogBox['title'] = "Country Code";
        this.dialogBox['content'] = "<TABLE BORDER=1 valign=top><TR><TD><B>Value</B></TD><TD><B>Description</B></TD></TR><TR><TD>AD</TD><TD>Andorra</TD></TR><TR><TD>AE</TD><TD>United Arab Emirates</TD></TR><TR><TD>AF</TD><TD>Afghanistan</TD></TR><TR><TD>AG</TD><TD>Antigua and Barbuda</TD></TR><TR><TD>AI</TD><TD>Anguilla</TD></TR><TR><TD>AL</TD><TD>Albania</TD></TR><TR><TD>AM</TD><TD>Armenia</TD></TR><TR><TD>AN</TD><TD>Netherlands Antilles</TD></TR><TR><TD>AO</TD><TD>Angola</TD></TR><TR><TD>AQ</TD><TD>Antarctica</TD></TR><TR><TD>AR</TD><TD>Argentina</TD></TR><TR><TD>AS</TD><TD>American Samoa</TD></TR><TR><TD>AT</TD><TD>Austria</TD></TR><TR><TD>AU</TD><TD>Australia</TD></TR><TR><TD>AW</TD><TD>Aruba</TD></TR><TR><TD>AZ</TD><TD>Azerbaijan</TD></TR><TR><TD>BA</TD><TD>Bosnia and Herzegovina</TD></TR><TR><TD>BB</TD><TD>Barbados</TD></TR><TR><TD>BD</TD><TD>Bangladesh</TD></TR><TR><TD>BE</TD><TD>Belgium</TD></TR><TR><TD>BF</TD><TD>Burkina Faso</TD></TR><TR><TD>BG</TD><TD>Bulgaria</TD></TR><TR><TD>BH</TD><TD>Bahrain</TD></TR><TR><TD>BI</TD><TD>Burundi</TD></TR><TR><TD>BJ</TD><TD>Benin</TD></TR><TR><TD>BM</TD><TD>Bermuda</TD></TR><TR><TD>BN</TD><TD>Brunei Darussalam</TD></TR><TR><TD>BO</TD><TD>Bolivia</TD></TR><TR><TD>BR</TD><TD>Brazil</TD></TR><TR><TD>BS</TD><TD>Bahamas</TD></TR><TR><TD>BT</TD><TD>Bhutan</TD></TR><TR><TD>BW</TD><TD>Botswana</TD></TR><TR><TD>BY</TD><TD>Belarus</TD></TR><TR><TD>BZ</TD><TD>Belize</TD></TR><TR><TD>CA</TD><TD>Canada</TD></TR><TR><TD>CC</TD><TD>Cocos (Keeling) Islands</TD></TR><TR><TD>CD</TD><TD>Congo Democratic Republic</TD></TR><TR><TD>CF</TD><TD>Central African Republic</TD></TR><TR><TD>CG</TD><TD>Congo, Republic of</TD></TR><TR><TD>CH</TD><TD>Switzerland</TD></TR><TR><TD>CI</TD><TD>Cote d'Ivoire</TD></TR><TR><TD>CK</TD><TD>Cook Islands</TD></TR><TR><TD>CL</TD><TD>Chile</TD></TR><TR><TD>CM</TD><TD>Cameroon</TD></TR><TR><TD>CN</TD><TD>China</TD></TR><TR><TD>CO</TD><TD>Colombia</TD></TR><TR><TD>CR</TD><TD>Costa Rica</TD></TR><TR><TD>CS</TD><TD>Serbia and Montenegro</TD></TR><TR><TD>CU</TD><TD>Cuba</TD></TR><TR><TD>CV</TD><TD>Cape Verde</TD></TR><TR><TD>CX</TD><TD>Christmas Island</TD></TR><TR><TD>CY</TD><TD>Cyprus</TD></TR><TR><TD>CZ</TD><TD>Czech Republic</TD></TR><TR><TD>DE</TD><TD>Germany</TD></TR><TR><TD>DJ</TD><TD>Djibouti</TD></TR><TR><TD>DK</TD><TD>Denmark</TD></TR><TR><TD>DM</TD><TD>Dominica</TD></TR><TR><TD>DO</TD><TD>Dominican Republic</TD></TR><TR><TD>DZ</TD><TD>Algeria</TD></TR><TR><TD>EC</TD><TD>Ecuador</TD></TR><TR><TD>EE</TD><TD>Estonia</TD></TR><TR><TD>EG</TD><TD>Egypt</TD></TR><TR><TD>EH</TD><TD>Western Sahara</TD></TR><TR><TD>ER</TD><TD>Eritrea</TD></TR><TR><TD>ES</TD><TD>Spain</TD></TR><TR><TD>ET</TD><TD>Ethiopia</TD></TR><TR><TD>FI</TD><TD>Finland</TD></TR><TR><TD>FJ</TD><TD>Fiji</TD></TR><TR><TD>FK</TD><TD>Falkland Islands (Malvinas)</TD></TR><TR><TD>FM</TD><TD>Micronesia, Federated States of</TD></TR><TR><TD>FO</TD><TD>Faroe Islands</TD></TR><TR><TD>FR</TD><TD>France</TD></TR><TR><TD>GA</TD><TD>Gabon</TD></TR><TR><TD>GB</TD><TD>United Kingdom</TD></TR><TR><TD>GD</TD><TD>Grenada</TD></TR><TR><TD>GE</TD><TD>Georgia</TD></TR><TR><TD>GF</TD><TD>French Guiana</TD></TR><TR><TD>GH</TD><TD>Ghana</TD></TR><TR><TD>GI</TD><TD>Gibraltar</TD></TR><TR><TD>GL</TD><TD>Greenland</TD></TR><TR><TD>GM</TD><TD>Gambia</TD></TR><TR><TD>GN</TD><TD>Guinea</TD></TR><TR><TD>GP</TD><TD>Guadeloupe</TD></TR><TR><TD>GQ</TD><TD>Equatorial Guinea</TD></TR><TR><TD>GR</TD><TD>Greece</TD></TR><TR><TD>GS</TD><TD>SOUTH GEORGIA</TD></TR><TR><TD>GT</TD><TD>Guatemala</TD></TR><TR><TD>GU</TD><TD>Guam</TD></TR><TR><TD>GW</TD><TD>Guinea-Bissau</TD></TR><TR><TD>GY</TD><TD>Guyana</TD></TR><TR><TD>HK</TD><TD>Hong Kong</TD></TR><TR><TD>HN</TD><TD>Honduras</TD></TR><TR><TD>HR</TD><TD>Croatia</TD></TR><TR><TD>HT</TD><TD>Haiti</TD></TR><TR><TD>HU</TD><TD>Hungary</TD></TR><TR><TD>ID</TD><TD>Indonesia</TD></TR><TR><TD>IE</TD><TD>Ireland</TD></TR><TR><TD>IL</TD><TD>Israel</TD></TR><TR><TD>IN</TD><TD>India</TD></TR><TR><TD>IQ</TD><TD>Iraq</TD></TR><TR><TD>IR</TD><TD>IRAN</TD></TR><TR><TD>IS</TD><TD>Iceland</TD></TR><TR><TD>IT</TD><TD>Italy</TD></TR><TR><TD>JM</TD><TD>Jamaica</TD></TR><TR><TD>JO</TD><TD>Jordan</TD></TR><TR><TD>JP</TD><TD>Japan</TD></TR><TR><TD>KE</TD><TD>Kenya</TD></TR><TR><TD>KG</TD><TD>Kyrgyzstan</TD></TR><TR><TD>KH</TD><TD>Kampuchea (Cambodia)</TD></TR><TR><TD>KI</TD><TD>Kiribati</TD></TR><TR><TD>KM</TD><TD>Comoros</TD></TR><TR><TD>KN</TD><TD>Saint Kitts and Nevis</TD></TR><TR><TD>KP</TD><TD>Korea, Democratic People's Republic of</TD></TR><TR><TD>KR</TD><TD>Korea</TD></TR><TR><TD>KW</TD><TD>Kuwait</TD></TR><TR><TD>KY</TD><TD>Cayman Islands</TD></TR><TR><TD>KZ</TD><TD>Kazakstan</TD></TR><TR><TD>LA</TD><TD>Lao, People's Democratic Republic</TD></TR><TR><TD>LB</TD><TD>Lebanon</TD></TR><TR><TD>LC</TD><TD>Saint Lucia</TD></TR><TR><TD>LI</TD><TD>Liechtenstein</TD></TR><TR><TD>LK</TD><TD>Sri Lanka</TD></TR><TR><TD>LR</TD><TD>Liberia</TD></TR><TR><TD>LS</TD><TD>Lesotho</TD></TR><TR><TD>LT</TD><TD>Lithuania</TD></TR><TR><TD>LU</TD><TD>Luxembourg</TD></TR><TR><TD>LV</TD><TD>Latvia</TD></TR><TR><TD>LY</TD><TD>Libyan Arab Jamahiriya</TD></TR><TR><TD>MA</TD><TD>Morocco</TD></TR><TR><TD>MC</TD><TD>Monaco</TD></TR><TR><TD>MD</TD><TD>Moldova</TD></TR><TR><TD>ME</TD><TD>Montenegro</TD></TR><TR><TD>MG</TD><TD>Madagascar</TD></TR><TR><TD>MH</TD><TD>Marshall Islands</TD></TR><TR><TD>MK</TD><TD>Macedonia, The Former Yugoslav Republic Of</TD></TR><TR><TD>ML</TD><TD>Mali</TD></TR><TR><TD>MM</TD><TD>Myanmar</TD></TR><TR><TD>MO</TD><TD>Macao</TD></TR><TR><TD>MP</TD><TD>Northern Mariana Islands</TD></TR><TR><TD>MQ</TD><TD>Martinique</TD></TR><TR><TD>MR</TD><TD>Mauritania</TD></TR><TR><TD>MS</TD><TD>Montserrat</TD></TR><TR><TD>MT</TD><TD>Malta</TD></TR><TR><TD>MU</TD><TD>Mauritius</TD></TR><TR><TD>MV</TD><TD>Maldives</TD></TR><TR><TD>MW</TD><TD>Malawi</TD></TR><TR><TD>MX</TD><TD>Mexico</TD></TR><TR><TD>MY</TD><TD>Malaysia</TD></TR><TR><TD>MZ</TD><TD>Mozambique</TD></TR><TR><TD>NA</TD><TD>Namibia</TD></TR><TR><TD>NE</TD><TD>Niger</TD></TR><TR><TD>NF</TD><TD>Norfolk Island</TD></TR><TR><TD>NG</TD><TD>Nigeria</TD></TR><TR><TD>NI</TD><TD>Nicaragua</TD></TR><TR><TD>NL</TD><TD>Netherlands</TD></TR><TR><TD>NO</TD><TD>Norway</TD></TR><TR><TD>NP</TD><TD>Nepal</TD></TR><TR><TD>NR</TD><TD>Nauru</TD></TR><TR><TD>NT</TD><TD>Neutral Zone</TD></TR><TR><TD>NU</TD><TD>Niue</TD></TR><TR><TD>NZ</TD><TD>New Zealand</TD></TR><TR><TD>OM</TD><TD>Oman</TD></TR><TR><TD>PA</TD><TD>Panama</TD></TR><TR><TD>PE</TD><TD>Peru</TD></TR><TR><TD>PF</TD><TD>French Polynesia</TD></TR><TR><TD>PG</TD><TD>Papua New Guinea</TD></TR><TR><TD>PH</TD><TD>Philippines</TD></TR><TR><TD>PK</TD><TD>Pakistan</TD></TR><TR><TD>PL</TD><TD>Poland</TD></TR><TR><TD>PM</TD><TD>Saint Pierre and Miquelon</TD></TR><TR><TD>PN</TD><TD>Pitcairn</TD></TR><TR><TD>PT</TD><TD>Portugal</TD></TR><TR><TD>PW</TD><TD>Palau</TD></TR><TR><TD>PY</TD><TD>Paraguay</TD></TR><TR><TD>QA</TD><TD>Qatar</TD></TR><TR><TD>RO</TD><TD>Romania</TD></TR><TR><TD>RS</TD><TD>Serbia</TD></TR><TR><TD>RU</TD><TD>Russia Federation</TD></TR><TR><TD>RW</TD><TD>Rwanda</TD></TR><TR><TD>SA</TD><TD>Saudi Arabia</TD></TR><TR><TD>SB</TD><TD>Solomon Islands</TD></TR><TR><TD>SC</TD><TD>Seychelles</TD></TR><TR><TD>SD</TD><TD>Sudan</TD></TR><TR><TD>SE</TD><TD>Sweden</TD></TR><TR><TD>SJ</TD><TD>Svalbard and Jan Mayen</TD></TR><TR><TD>SG</TD><TD>Singapore</TD></TR><TR><TD>SH</TD><TD>Saint Helena</TD></TR><TR><TD>SI</TD><TD>Slovenia</TD></TR><TR><TD>SK</TD><TD>Slovakia</TD></TR><TR><TD>SL</TD><TD>Sierra Leone</TD></TR><TR><TD>SM</TD><TD>San Marino</TD></TR><TR><TD>SN</TD><TD>Senegal</TD></TR><TR><TD>SO</TD><TD>Somalia</TD></TR><TR><TD>SR</TD><TD>Suriname</TD></TR><TR><TD>ST</TD><TD>Sao Tome and Principe</TD></TR><TR><TD>SV</TD><TD>El Salvador</TD></TR><TR><TD>SY</TD><TD>Syrian Arab Republic</TD></TR><TR><TD>SZ</TD><TD>Swaziland</TD></TR><TR><TD>TC</TD><TD>Turks and Caicos Islands</TD></TR><TR><TD>TD</TD><TD>Chad</TD></TR><TR><TD>TF</TD><TD>French Southern Territories</TD></TR><TR><TD>TG</TD><TD>Togo</TD></TR><TR><TD>TH</TD><TD>Thailand</TD></TR><TR><TD>TJ</TD><TD>Tajikistan</TD></TR><TR><TD>TK</TD><TD>Tokelau</TD></TR><TR><TD>TL</TD><TD>Timor-Leste</TD></TR><TR><TD>TM</TD><TD>Turkmenistan</TD></TR><TR><TD>TN</TD><TD>Tunisia</TD></TR><TR><TD>TO</TD><TD>Tonga</TD></TR><TR><TD>TR</TD><TD>Turkey</TD></TR><TR><TD>TT</TD><TD>Trinidad and Tobago</TD></TR><TR><TD>TV</TD><TD>Tuvalu</TD></TR><TR><TD>TW</TD><TD>Taiwan</TD></TR><TR><TD>TZ</TD><TD>Tanzania, United Republic of</TD></TR><TR><TD>UA</TD><TD>Ukraine</TD></TR><TR><TD>UG</TD><TD>Uganda</TD></TR><TR><TD>UM</TD><TD>United States Minor Outlying Islands</TD></TR><TR><TD>US</TD><TD>United States</TD></TR><TR><TD>UY</TD><TD>Uruguay</TD></TR><TR><TD>UZ</TD><TD>Uzbekistan</TD></TR><TR><TD>VC</TD><TD>Saint Vincent & the Grenadines</TD></TR><TR><TD>VE</TD><TD>Venezuela</TD></TR><TR><TD>VG</TD><TD>BRITISH VIRGIN ISLANDS</TD></TR><TR><TD>VN</TD><TD>VIETNAM</TD></TR><TR><TD>VU</TD><TD>Vanuatu</TD></TR><TR><TD>WS</TD><TD>Samoa</TD></TR><TR><TD>XB</TD><TD>Turkish Republic of Northern Cyprus</TD></TR><TR><TD>YD</TD><TD>Yemen, Democratic</TD></TR><TR><TD>YE</TD><TD>Yemen</TD></TR><TR><TD>ZA</TD><TD>SOUTH AFRICA</TD></TR><TR><TD>ZM</TD><TD>Zambia</TD></TR><TR><TD>ZW</TD><TD>Zimbabwe</TD></TR></TABLE> ";
        break;
      }
      case "TradeUpModal": {
        this.dialogBox['title'] = "Trade Up";
        this.dialogBox['content'] = "<TABLE BORDER=1 valign=top><TR><TD><B>Value</B></TD><TD><B>Description</B></TD></TR><TR><TD>Y</TD><TD>Yes</TD></TR><TR><TD>y</TD><TD>Yes</TD></TR><TR><TD>N</TD><TD>No</TD></TR><TR><TD>n</TD><TD>No</TD></TR></TABLE>";
        break;
      }
      case "IgnoreMissingFieldsModal": {
        this.dialogBox['title'] = "Ignore Missing Fields";
        this.dialogBox['content'] = "<TABLE BORDER=1 valign=top><TR><TD><B>Value</B></TD><TD><B>Description</B></TD></TR><TR><TD>Y</TD><TD>Yes</TD></TR><TR><TD>y</TD><TD>Yes</TD></TR><TR><TD>N</TD><TD>No</TD></TR><TR><TD>n</TD><TD>No</TD></TR></TABLE>";
        break;
      }
      case "ExcludeBranchIndicatorModal": {
        this.dialogBox['title'] = "Exclude Branch Indicator";
        this.dialogBox['content'] = "<TABLE BORDER=1 valign=top><TR><TD><B>Value</B></TD><TD><B>Description</B></TD></TR><TR><TD>Y</TD><TD>Yes</TD></TR><TR><TD>y</TD><TD>Yes</TD></TR><TR><TD>N</TD><TD>No</TD></TR><TR><TD>n</TD><TD>No</TD></TR></TABLE>";
        break;
      }
      case "NotFromCacheModal": {
        this.dialogBox['title'] = "Not from cache";
        this.dialogBox['content'] = "<TABLE BORDER=1 valign=top><TR><TD><B>Value</B></TD><TD><B>Description</B></TD></TR><TR><TD>Y</TD><TD>Yes</TD></TR><TR><TD>y</TD><TD>Yes</TD></TR><TR><TD>N</TD><TD>No</TD></TR><TR><TD>n</TD><TD>No</TD></TR></TABLE>";
        break;
      }
      case "ModeModal": {
        this.dialogBox['title'] = "Mode";
        this.dialogBox['content'] = "<TABLE BORDER=1 valign=top><TR><TD><B>Value</B></TD><TD><B>Description</B></TD></TR><TR><TD>DIRECT</TD><TD>Direct mode</TD></TR><TR><TD>Direct</TD><TD>Direct mode</TD></TR><TR><TD>direct</TD><TD>Direct mode</TD></TR></TABLE>";
        break;
      }
      case "FormatModal": {
        this.dialogBox['title'] = "Format";
        this.dialogBox['content'] = "<TABLE BORDER=1 valign=top><TR><TD><B>Value</B></TD><TD><B>Description</B></TD></TR><TR><TD>XML</TD><TD>XML  format</TD></TR><TR><TD>Xml</TD><TD>XML  format</TD></TR><TR><TD>xml</TD><TD>XML  format</TD></TR></TABLE>";
        break;
      }
      case "FamilyTreeProductModal": {
        this.dialogBox['title'] = "Family Tree Product";
        this.dialogBox['content'] = "<TABLE BORDER=1 valign=top><TR><TD><B>Value</B></TD><TD><B>Description</B></TD></TR><TR><TD>Family Tree - Basic</TD><TD>Family Tree - Basic :  determines family members of a business to help uncover new selling opportunities, negotiate global purchasing agreements and perform merger and market analysis.</TD></TR><TR><TD>Family Tree - Enhanced</TD><TD>Family Tree - Enhanced: identifies worldwide family members with more detailed information on each business</TD></TR></TABLE>";
        break;
      }
      case "BusinessRelationshipModal": {
        this.dialogBox['title'] = "Business Relationship";
        this.dialogBox['content'] = `<TABLE BORDER=1 valign=top><TR><TD><B>Value</B></TD><TD><B>Description</B></TD></TR><TR><TD>0</TD><TD>Domestic Ultimate -The domestic ultimate is the highest member of the tree in the same country as the business in a particular "limb" of a tree. There may be multiple domestic ultimates in the same country for the same tree if they are each on a different "limb" of the tree.</TD></TR></TABLE>`;
        break;
      }
      case "RPTLanguageModal": {
        this.dialogBox['title'] = "Rpt Language";
        this.dialogBox['content'] = "<TABLE BORDER=1 valign=top><TR><TD><B>Value</B></TD><TD><B>Description</B></TD></TR><TR><TD>EN</TD><TD>English</TD></TR><TR><TD>en</TD></TR><TR><TD>FR</TD><TD>French</TD></TR><TR><TD>fr</TD></TR><TR><TD>GE</TD><TD>German</TD></TR><TR><TD>ge</TD></TR><TR><TD>SP</TD><TD>Spanish</TD></TR><TR><TD>sp</TD></TR><TR><TD>PO</TD><TD>Portuguese</TD></TR><TR><TD>po</TD></TR><TR><TD>IT</TD><TD>Italian</TD></TR><TR><TD>it</TD></TR><TR><TD>DU</TD><TD>Dutch</TD></TR><TR><TD>du</TD></TR></TABLE>";
        break;
      }
      case "ServiceModal": {
        this.dialogBox['title'] = "Service";
        this.dialogBox['content'] = "<TABLE BORDER=1 valign=top><TR><TD><B>Value</B></TD><TD><B>Description</B></TD></TR><TR><TD>NORMAL</TD></TR><TR><TD>PRIORITY</TD></TR></TABLE>";
        break;
      }
      case "ModeModal": {
        this.dialogBox['title'] = "Mode";
        this.dialogBox['content'] = "<TABLE BORDER=1 valign=top><TR><TD><B>Value</B></TD><TD><B>Description</B></TD></TR><TR><TD>DIRECT</TD><TD>Direct mode</TD></TR><TR><TD>Direct</TD><TD>Direct mode</TD></TR><TR><TD>direct</TD><TD>Direct mode</TD></TR></TABLE>";
        break;
      }
      case "FormatModal": {
        this.dialogBox['title'] = "Format";
        this.dialogBox['content'] = "<TABLE BORDER=1 valign=top><TR><TD><B>Value</B></TD><TD><B>Description</B></TD></TR><TR><TD>XML</TD><TD>XML  format</TD></TR><TR><TD>Xml</TD><TD>XML  format</TD></TR><TR><TD>xml</TD><TD>XML  format</TD></TR></TABLE>";
        break;
      }
      case "RptLanguageModal": {
        this.dialogBox['title'] = "Rpt Language";
        this.dialogBox['content'] = "<TABLE BORDER=1 valign=top><TR><TD><B>Value</B></TD><TD><B>Description</B></TD></TR><TR><TD>EN</TD><TD>English</TD></TR><TR><TD>en</TD></TR><TR><TD>FR</TD><TD>French</TD></TR><TR><TD>fr</TD></TR><TR><TD>GE</TD><TD>German</TD></TR><TR><TD>ge</TD></TR><TR><TD>SP</TD><TD>Spanish</TD></TR><TR><TD>sp</TD></TR><TR><TD>PO</TD><TD>Portuguese</TD></TR><TR><TD>po</TD></TR><TR><TD>IT</TD><TD>Italian</TD></TR><TR><TD>it</TD></TR><TR><TD>DU</TD><TD>Dutch</TD></TR><TR><TD>du</TD></TR></TABLE>";
        break;
      }
      case "StateProvinceModal": {
        this.dialogBox['title'] = "State/Province";
        this.dialogBox['content'] = "<TABLE BORDER=1 valign=top><TR><TD><B>Value</B></TD><TD><B>Description</B></TD></TR></TABLE>";
        break;
      }
      case "PrimayBureauIdModal": {
        this.dialogBox['title'] = "Primay Bureau Id";
        this.dialogBox['content'] = "<TABLE BORDER=1 valign=top><TR><TD><B>Value</B></TD><TD><B>Description</B></TD></TR><TR><TD>EFU</TD><TD>EquiFax US</TD></TR><TR><TD>TU</TD><TD>Trans Union US</TD></TR><TR><TD>XPN</TD><TD>Experian</TD></TR></TABLE>";
        break;
      }
      case "AlternateBureauIdModal": {
        this.dialogBox['title'] = "Alternate Bureau Id";
        this.dialogBox['content'] = "<TABLE BORDER=1 valign=top><TR><TD><B>Value</B></TD><TD><B>Description</B></TD></TR><TR><TD>EFU</TD><TD>EquiFax US</TD></TR><TR><TD>TU</TD><TD>Trans Union US</TD></TR><TR><TD>XPN</TD><TD>Experian</TD></TR></TABLE>";
        break;
      }
      case "ResidenceTypeModal": {
        this.dialogBox['title'] = "Residence Type";
        this.dialogBox['content'] = "<TABLE BORDER=1 valign=top><TR><TD><B>Value</B></TD><TD><B>Description</B></TD></TR><TR><TD>H</TD><TD>Owns/Buying</TD></TR><TR><TD>M</TD><TD>Miscellanous</TD></TR><TR><TD>R</TD><TD>Rent</TD></TR><TR><TD>P</TD><TD>Live with parents/relative</TD></TR></TABLE>";
        break;
      }
      default: {
        break;
      }
    }
    return this.dialogBox;
  }
}
